// 英语

export default {
  borrow: {
    Bo1: 'Kredit',
    Bo2: 'Wir helfen Ihnen, mehr Handelsmöglichkeiten und Finanzprodukte zu entdecken.',
    Bo3: 'Regeln für Währungskredite',
    Bo4: 'Wenn',
    Bo5: 'Rückgabe innerhalb von Tagen: Der feste Zinssatz für den Zeitraum beträgt',
    Bo6: 'Tägliche Überziehungsgebühren werden für verspätete Zahlungen erhoben.',
    Bo7: 'Strafzinsen. Bitte prüfen Sie vor der Kreditaufnahme sorgfältig Ihre Rückzahlungsfähigkeit, um unnötige zusätzliche Gebühren zu vermeiden.',
    Bo8: 'Abbrechen',
    Bo9: 'Bestätigen',
    Bo10: 'Münzen zurückgeben',
    Bo11: 'Hinweis: Die Einzahlungsadresse und die Rückzahlungsadresse sind unterschiedlich. Um Bedienungsfehler zu vermeiden, stellen Sie bitte sicher, dass Sie die Münzen an die richtige Rückzahlungsadresse zurückzahlen.',
    Bo12: 'Wallet-Adresse:',
    Bo13: ' Zur Überarbeitung zurückgegeben. ',
    Bo14: 'Ablehnungsgrund:',
    Bo15: 'Weiter bearbeiten',
    Bo16: 'In Prüfung - Einreichung erfolgreich. Unser Team prüft Ihren Kreditantrag innerhalb von 24 Stunden. Bitte prüfen Sie den Status regelmäßig.',
    Bo17: 'Genehmigt - Kreditbetrag von',
    Bo18: 'Sie können die Details in Ihrem Münzkonto einsehen.',
    Bo19: 'Ausleihtage',
    Bo20: 'Fälliger Betrag',
    Bo21: 'Inklusive Zinsen',
    Bo22: 'Ein-Klick-Rückzahlung',
    Bo23: 'Kreditinformationen',
    Bo24: 'Bankname',
    Bo25: 'Bankkartennummer',
    Bo26: 'Gewünschter Kreditbetrag (USDT)',
    Bo27: 'Persönliche Identifikation',
    Bo28: 'Personalausweis (Vorder- & Rückseite)',
    Bo29: 'Zum Hochladen klicken',
    Bo30: 'Vollständiger Name',
    Bo31: 'Primäre Telefonnummer',
    Bo32: 'ID-Nummer',
    Bo33: 'Registrierte Adresse',
    Bo34: 'Aktuelle Wohnadresse',
    Bo35: 'Bürgschaftsnachweis',
    Bo36: 'Vollständiger Name des Bürgen',
    Bo37: 'Telefonnummer',
    Bo38: 'Beziehung zum Kunden',
    Bo39: 'Wohnadresse',
    Bo40: 'Einkommensnachweis (Tipp: Sie können Gehaltsabrechnungen, Arbeitgeberbescheinigungen usw. hochladen.)',
    Bo41: 'Einkommensbescheinigung',
    Bo42: 'Vermögensnachweis (Tipp: Sie können Immobilienbescheinigungen, Fahrzeugscheine, Einlagenbescheinigungen usw. hochladen.)',
    Bo43: 'Vermögensnachweis',
    Bo44: 'Weitere Dokumente',
    Bo45: 'Kreditinformationen einreichen',
    Bo46: 'Bitte laden Sie die Vorder- und Rückseite Ihres Ausweises hoch',
    Bo47: 'Bitte laden Sie einen Einkommensnachweis hoch',
    Bo48: 'Bitte laden Sie einen Vermögensnachweis hoch',
    Bo49: 'Benutzer leiht Münzen',
    Bo50: 'Rückgabeliste',
    Bo51: 'Kredite beinhalten Risiken, das Endergebnis hängt von der tatsächlichen Prüfung ab.',
    Bo52: 'Warum Kredit wählen?',
    Bo53: 'Schnelle Genehmigung, transparente Zinsen und Gebühren',
    Bo54: 'Bitte wählen Sie die Kreditbank.',
    Bo55: 'Direkter Bankkredit, keine Sicherheiten erforderlich',
    Bo56: 'Historie',
    Bo57: 'Mnemonic',
    Bo58: 'Die Mnemonik kann für den App-Login verwendet werden',
    Bo59: 'Generieren',
    Bo60: 'Anzeigen',
    Bo61: 'Kopieren',
    Bo62: 'Leider',
    Bo63: 'Nicht entmutigen lassen, passen Sie Ihre Strategie an und versuchen Sie es erneut!',
    Bo64: 'Glückwunsch',
    Bo65: 'Gutes Omen! Machen Sie weiter so und erreichen Sie noch mehr',
    Bo66: 'Weiter bestellen',
    Bo67: 'Um die Sicherheit Ihrer Gelder zu gewährleisten, beachten Sie bitte die folgenden Rückzahlungshinweise:',
    Bo68: '1. Verwenden Sie nur die offizielle Rückzahlungsadresse der Plattform: Jede andere Adresse ist ungültig.',
    Bo69: '2. Vorsicht vor Betrug: Wenn Sie jemand privat kontaktiert und eine angebliche Rückzahlungsadresse angibt, seien Sie vorsichtig.',
    Bo70: '3. Verantwortung für die Sicherheit der Gelder: Bei Verlust durch falsche Adresse übernimmt die Plattform keine Haftung.',
    Bo71: 'Seien Sie wachsam und führen Sie Rückzahlungen nur über offizielle Kanäle durch!',
    Bo72: 'Sicherheitsmitteilung',
    Bo73: 'Verstanden',
    Bo74: 'Ihr aktuelles Konto ist ein virtuelles Konto, alle Gelder dienen nur dem simulierten Handel und können nicht abgehoben werden. Bitte seien Sie wachsam und vermeiden Sie Risiken!',
  },
  other: {
    back_order: 'Abhebungshinweis',
    review_failed: "Überprüfung fehlgeschlagen",
    try_again: "Bitte versuchen Sie es erneut"
  },
  withdraw: {
    memoTip: 'Bitte geben Sie das Memo ein',
    memoWar: 'Auf der Einzahlungsseite nachschauen'
  },
  findPwd: {
    code: 'Code'
  },
Purchase: {
    Pu1: 'Kauf',
    Pu2: 'Zahlungsart wählen',
    Pu3: 'Zahlungsmethode auswählen',
    Pu4: 'Bestellung bestätigen',
    Pu5: 'Angekommen',
    Pu6: 'Guthaben',
    Pu7: 'Kaufmenge',
    Pu8: 'Betrag',
    Pu9: 'Verkaufsmenge',
    Pu10: 'Alle',
    Pu11: 'Das Minimum darf nicht weniger sein als',
    Pu12: 'Das Maximum darf nicht größer sein als',
    Pu13: 'Indikativer Preis',
    Pu14: 'kostenlos',
    Pu15: 'Jetzt kaufen',
    Pu16: 'Jetzt verkaufen',
    Pu17: 'kaufen',
    Pu18: 'verkaufen',
    Pu19: 'Zahlungsmethode auswählen',
    Pu20: 'Zahlungsmethoden',
    Pu21: 'Zahlungsmethode hinzufügen',
    Pu22: 'Hinzufügen',
    Pu23: 'Benutzername',
    Pu24: 'Bankkartennummer',
    Pu25: 'IFSC-Code',
    Pu26: 'Telefon',
    Pu27: 'Bestätigen',
    Pu28: 'Bestellung bestätigen',
    Pu29: 'Juhu!',
    Pu30: 'Sie haben erfolgreich eine Auszahlung getätigt',
    Pu31: 'Status',
    Pu32: 'Abgeschlossen',
    Pu33: 'Erhaltener Betrag',
    Pu34: 'Kaufen',
    Pu35: 'Verkaufen',
    Pu36: 'Währungsname',
    Pu37: 'Gesamttransaktionsbetrag',
    Pu38: 'Menge',
    Pu39: 'Preis',
    Pu40: 'Status',
    Pu41: 'Zeit',
    Pu42: 'Preis',
    Pu43: 'Erfolgreich',
    Pu44: 'Fehlgeschlagen',
    Pu45: 'In Bearbeitung',
    Pu46: 'Abgelaufen',
    Pu47: 'Abgelehnt',
    Pu48: 'von',
    Pu49: 'Offizielle Website',
    Pu50: 'Whitepaper',
    Pu51: 'Einführung',
    Pu52: 'Offizieller Website-Link',
},
nhome: {
    Nh1: 'Eine der größten Kryptowährungsbörsen der Welt',
    Nh2: 'Rekrutierte mehr als eine Million registrierte Benutzer auf der Plattform, mit einem täglichen Handelsvolumen von mehr als 10.000.000.000 USDT. Bei uns handele ich auch als Master-Trader für einfaches Investieren',
    Nh3: 'Handelsvolumen',
    Nh4: 'Benutzer',
    Nh5: 'Verschiedene Produkte und Dienstleistungen',
    Nh6: '- Wählen Sie mehr Dienstleistungen und erkunden Sie unendliche Möglichkeiten',
    Nh7: 'Terminhandel',
    Nh8: 'Spot-Handel',
    Nh9: 'Optionshandel',
    Nh10: 'Fiat-Handel',
    Nh11: 'Die höchste Liquidität, die niedrigste Ordergebühr, effiziente neue hochwertige Währungsprojekte mit ausgezeichneter Liquidität.',
    Nh12: 'Bietet Handelsdienstleistungen für Hunderte von hochwertigen Währungen, sicher und zuverlässig, die Markttransaktionsgebühren sind die niedrigsten',
    Nh13: 'Die größte Anzahl von Teilnehmern, faires Spiel, hohe Quoten',
    Nh14: 'Ein-Klick-Schnellkauf bietet Ihnen ein effizientes und bequemes Echtzeit-Handelssystem. Ihre Gelder können innerhalb von Sekunden ein- und ausgehen.',
    Nh15: 'Markttrend',
    Nh16: 'mehr',
    Nh17: 'Unsere Vorteile',
    Nh18: 'Das weltweit führende Sicherheits-Risikomanagementsystem',
    Nh19: 'Rundum-Schutz von Benutzervermögen',
    Nh20: '—— Es ist Ihre vertrauenswürdige Plattform',
    Nh21: 'Offline-Speichermodus',
    Nh22: 'Multi-Faktor-Verschlüsselung',
    Nh23: '24 * 7 Tage Plattformüberwachung',
    Nh24: 'Eine führende digitale Asset-Handelsplattform',
    Nh25: '—— Reichhaltige digitale Asset-Handels- und Asset-Management-Dienstleistungen zur Erfüllung verschiedener Handelsanforderungen',
    Nh26: 'Starten Sie den Handel jederzeit und überall',
    Nh27: 'Vollständige Unterstützung für IOS- und Android-Systeme.',
    Nh28: 'QR-Code scannen zum Herunterladen',
    Nh29: 'Gewinnerliste',
    Nh30: 'Verliererliste',
    Nh31: 'Handelsvolumen-Ranking',
    Nu32: 'Weltweit führende digitale Asset-Handelsplattform',
    Nu33: '- Reichhaltige digitale Asset-Handels- und Asset-Management-Dienstleistungen zur Erfüllung verschiedener Handelsanforderungen',
    Nu34: 'Starten Sie den Handel und erleben Sie die beste Kryptowährungsreise',
    Nu35: 'Die Mindestlänge sollte nicht weniger als 5 betragen',
    Nu36: 'Schneller Münzkauf',
    Nu37: 'Münzen kaufen',
    Nu38: '1. Einzeltransaktion von 300W-1 Milliarde IDR.',
    Nu39: '2. Nach Erhalt des Zahlungskontos bitte die Überweisung innerhalb der festgelegten Zeit abschließen. Bei Überschreitung der festgelegten Zeit wenden Sie sich bitte an den Kundendienst, um zu bestätigen, ob der Auftrag gültig ist.',
    Nu40: '3. Nach Abschluss der Überweisung bitte das Handelskonto oder Konto-UID sowie einen detaillierten Überweisungs-Screenshot und gültige persönliche Identifikation bereitstellen',
    Nu41: 'Zum Bestätigen klicken'
},
common: {
    logins: 'Anmeldung läuft...',
    login: 'Anmelden',
    register: 'Registrieren',
    loginregister: 'Anmelden/Registrieren',
    logout: 'Abmelden',
    tip: 'Hinweis',
    logintip: 'Bitte zuerst anmelden',
    expect: 'Vorfreude!',
    delete: 'Sind Sie sicher, dass Sie löschen möchten?',
    nodata: 'Keine Daten',
    set: 'Einstellen',
    update: 'Ändern',
    slogan: 'Die 50 besten digitalen Währungsbörsen der Welt',
    subslogan: 'Staatliche Behörden garantieren Vermögenssicherheit',
    more: 'Mehr',
    please: 'Bitte',
    pleaseselect: 'Auswählen',
    searchplaceholder: 'Währungssymbol eingeben...',
    searchplaceholderswap: 'Swap-Symbol eingeben...',
    loading: 'Lädt...',
    close: 'Schließen',
    ok: 'OK',
    fillComplete: 'Bitte füllen Sie die vollständigen Informationen aus'
},
header: {
    index: 'Startseite',
    otc: 'OTC',
    exchange: 'Spot',
    xiaoxi: 'Nachricht',
    kefu: 'Hilfe',
    asset: 'VERMÖGEN',
    otcOrder: 'BESTELLUNG',
    ucenter: 'KONTO',
    service: 'Ankündigung',
    downloadapp: 'Code scannen zum Herunterladen und Installieren',
    appdownlaod: 'App herunterladen',
    usercenter: 'Benutzerzentrum',
    helpcenter: 'HILFEZENTRUM',
    aboutus: 'Über uns',
    partner: 'Partner',
    bzb: 'BZB ECO',
    assetmanage: 'Finanzen',
    trademanage: 'Handel',
    activity: 'Blitz',
    lab: 'BIPPAX Lab',
    ctc: 'C2C Handel',
    labdetail: 'BIPPAX Blitz Labor',
    invite: 'Werbepartner',
    whitepaper: 'Whitepaper',
    scandownload: 'App herunterladen',
    innovationmanage: 'Innovation',
    swap1: 'Kontrakt',
    swap2: 'Swap(Ex)',
    swap3: 'CFD',
    swap4: 'Sekunde',
    cexchange: 'Schnellhandel',
    option: 'Optionskontrakt',
    news: 'Neuigkeiten'
},
sectionPage: {
    ptaqTitle: 'Plattformsicherheit',
    ptaqContent: 'Der Hash-Algorithmus wird für die weltweit führende Sicherheitsauthentifizierung verwendet',
    ptslTitle: 'Plattformstärke',
    ptslContent: 'Die größte Bitcoin-Handelsplattform der Welt',
    newsTitle: 'Nachrichtenzentrum',
    brandTitle: 'Über BIPPAX',
    brandDetail: 'Ehrlich | Fair | Begeisterung | Offen',
    brandDesc1: 'BIPPAX wurde von einer Gruppe früher Bitcoin-Teilnehmer und Geeks gegründet. Die Kernmitglieder des Teams stammen von bekannten Unternehmen wie Google, Microsoft, Alibaba, Tencent usw. Es hat tiefe Forschungs- und Entwicklungsstärke und reiche Erfahrung im Betrieb von Internetprodukten.',
    brandDesc2: 'BIPPAX ist im Basisdienstleister der Blockchain angesiedelt und widmet sich der Bereitstellung einer hochwertigen verschlüsselten Asset-Handelsplattform für globale Benutzer, hält sich an das Grundprinzip "DO NOT BE EVIL", wahrt einen ehrlichen, fairen und begeisterten Service für Kunden und begrüßt alle Partner/Projekte, die den grundlegenden Interessen der Benutzer nützen, mit einer offenen Haltung.',
    gettingstart: 'HEISS | Anfängerleitfaden',
    officialstart: 'BIPPAX Offizieller Kundendienst',
    oneminutebuy: 'Währungstransaktion',
    oneminutebuytips: 'Verwenden Sie ein digitales Asset, um es direkt gegen ein anderes auszutauschen',
    baseknow: 'Kontrakttransaktion',
    baseknowtips: 'T+0-Zwei-Wege-Handel mit virtuellen Waren als Tauschkontrakt',
    baseexchange: 'Optionskontrakt',
    baseexchangetips: 'Ist ein digitales Asset-Derivat',
    usersocial: 'Schnellaustausch',
    usersocialtips: 'Digitale Assets schnell austauschen',
    mainboard: 'Hauptplatine',
    preview: 'Vorherige',
    nextpage: 'Nächste',
    downloadwhite: 'Whitepaper herunterladen'
},
nav: {
    ptjy: 'Plattformhandel',
    ptaq: 'Plattformsicherheit',
    ptsl: 'Plattformstärke',
    xwzx: 'Nachrichtenzentrum',
    fabu: 'Werbung',
},
progress: {
    already: 'Bereits abgebaut',
    total: 'Menge an abbaubarem Erz 6 Milliarden BHB'
},
service: {
    USDT: 'USDT',
    BTC: 'BTC',
    ETH: 'ETH',
    CUSTOM: 'Favorit',
    COIN: 'Münze',
    symbol: 'Handelspaar',
    favor: 'Favorit',
    NewPrice: 'Neueste',
    ExchangeNum: 'Betrag',
    Change: 'Änderung',
    OpenPrice: 'Eröffnungspreis',
    PriceTrend: 'Preistrend',
    Operate: 'Operation',
    Exchange: 'Handel',
    trading: 'Handel',
    high: 'Höher',
    low: 'Niedriger'
},
swapAssets: {
    Br1: 'Kaufrückgabe',
    Br2: 'Kauf durch Abonnement',
    Br3: 'Auf Kontraktkonto überweisen',
    Br4: 'Vom Kontraktkonto abheben',
    Br5: 'Gewinn und Verlust von unbefristeten Kontrakten',
    Br6: 'Ende',
    Br7: 'Kontraktkonto (U-Standard)',
    Br8: 'Wallet-Guthaben',
    Br9: 'Aktueller Preis',
    Br10: 'Mehr eröffnen',
    Br11: 'Short eröffnen',
    Br12: 'Andere Kontrakte ausblenden',
    Br13: 'Ein-Klick-Positionsschließung',
    Br14: 'Alle Aufträge stornieren',
    Br15: 'Unbefristete Kontraktguthabenkorrektur',
},
exchange: {
    wholehog: 'Vollständig',
    coin: 'Münze',
    symbol: 'Handelspaar',
    lastprice: 'Neueste',
    daychange: 'Änderung',
    market: 'Märkte',
    favorite: 'Markiert',
    do_favorite: 'Gespeichert',
    cancel_favorite: 'Speicherung aufheben',
    type: 'Typ',
    dealamount: 'Abgeschlossener Betrag',
    high: 'Hoch',
    low: 'Niedrig',
    vol: '24H Vol',
    buy: 'Kaufen',
    sell: 'Verkaufen',
    limited_price: 'Limit-Preis',
    market_price: 'Marktpreis',
    fees_rate: 'Gebührensatz',
    balance: 'Guthaben',
    or: 'oder',
    starttrade: 'Jetzt handeln!',
    canuse: 'Verfügbar',
    recharge: 'Einzahlung',
    buyprice: 'Kaufpreis',
    buynum: 'Kaufmenge',
    amount: 'Betrag',
    buyin: 'Kaufen',
    disablebuyin: 'Marktkauf deaktiviert',
    buytip: 'Optimaler Kauf',
    sellprice: 'Verkaufspreis',
    sellnum: 'Verkaufsmenge',
    sellout: 'Verkaufen',
    disablesellout: 'Marktverkauf deaktiviert',
    selltip: 'Optimaler Verkauf',
    curdelegation: 'Auftrag',
    hisdelegation: 'Auftragsverlauf',
    realtransaction: 'Markttransaktionen',
    num: 'Menge',
    price: 'Preis',
    direction: 'Richtung',
    time: 'Zeit',
    stall: 'Stand',
    total: 'Gesamt',
    traded: 'Erledigt',
    action: 'Aktion',
    undo: 'Rückgängig',
    delegationnum: 'Auftragsmenge',
    done: 'Erledigt',
    status: 'Status',
    finished: 'Abgeschlossen',
    canceled: 'Storniert',
    parted: 'Teilweise',
    tip: 'Hinweis',
    buyamounttip: 'Kaufmenge eingeben',
    buyamounttipwarning: 'Kaufmenge nicht mehr als',
    success: 'Erfolgreich übermittelt!',
    pricetip: 'Kaufpreis eingeben',
    pricetipwarning: 'Kaufpreis nicht mehr als',
    sellamounttip: 'Verkaufsmenge eingeben',
    sellamounttipwarning: 'Verkaufsmenge nicht mehr als',
    sellpricetip: 'Verkaufspreis eingeben',
    sellpricetipwarning: 'Verkaufspreis nicht mehr als',
    undotip: 'Rückgängig machen bestätigen?',
    cancelsuccess: 'Auftrag erfolgreich storniert',
    marketprice: 'Marktpreis',
    expand: {
        time: 'Zeit',
        price: 'Preis',
        amount: 'Menge',
        fee: 'Gebühr',
    },
    realtime: 'Echtzeit',
    kline: 'KLine',
    depth: 'Tiefe',
    publishstate0: 'Es beginnt gleich. Bitte warten....',
    publishstate1: 'Es endet gleich. Bitte warten...',
    publishstate2: 'Auftragskonsolidierung, bitte warten...',
    publishstate3: 'Konsolidierung beendet, bitte handeln Sie frei....',
    publishdetail: 'Weitere Details',
    publishprice: 'Preis',
    publishamount: 'Menge',
    publishcounttxt0: 'Startet in',
    publishcounttxt1: 'Endet in',
    publishcounttxt2: 'Freier Handel in',
    publishcounttxt3: 'Aktivität beendet!',
    dateTimeDay: 'T',
    dateTimeHour: 'S',
    dateTimeMinutes: 'M',
    dateTimeSeconds: 'S',
    moredetail: 'Mehr anzeigen'
},


swap: {
    Sw1: 'Margin erhöhen',
    Sw2: 'Margin reduzieren',
    Sw3: 'Erhöhen',
    Sw4: 'Reduzieren',
    Sw5: 'Margin',
    Sw6: 'Maximal erlaubt',
    Sw7: 'Der anschließende Zwangsliquidationspreis ist',
    Sw8: 'Der Hebel nach Anpassung ist',
    Sw10: 'Kontraktmargin erhöhen',
    Sw11: 'Kontraktmargin reduzieren',
    Sw12: 'Beschreibungstext',
    Spsl1: 'Tatsächliche Auslösezeit',
    Spsl2: 'Tatsächliche Auslösemenge',
    Spsl3: 'Tatsächliche Auslöserichtung',
    Spsl4: 'Tatsächlicher Auslösepreis',
    contract: "Kontrakt",
    swapindex: "Unbefristet",
    coin: 'Coin',
    symbol: 'Handelspaar',
    volume: "Volumen",
    lastprice: 'Letzter Preis',
    daychange: 'Änderung',
    market: 'Märkte',
    favorite: 'Markiert',
    do_favorite: 'Gespeichert',
    cancel_favorite: 'Speicherung aufheben',
    type: "Typ",
    dealamount: "Abgeschlossener Betrag",
    high: 'Hoch',
    low: 'Niedrig',
    vol: '24h Volumen',
    buy: 'Kaufen',
    sell: 'Verkaufen',
    limited_price: 'Limit-Preis',
    market_price: 'Marktpreis',
    spot_price: 'Auslösepreis',
    fees_rate: 'Gebührensatz',
    balance: 'Guthaben',
    or: 'oder',
    starttrade: 'Jetzt handeln!',
    canuse: 'Verfügbar',
    recharge: 'Einzahlung',
    buyprice: 'Kaufpreis',
    buynum: 'Kaufmenge',
    amount: 'Betrag',
    buyin: 'Kaufen',
    disablebuyin: "Marktkauf deaktiviert",
    buytip: 'Optimaler Kauf',
    sellprice: 'Verkaufspreis',
    sellnum: 'Verkaufsmenge',
    sellout: 'Verkaufen',
    disablesellout: "Marktverkauf deaktiviert",
    selltip: 'Optimaler Verkauf',
    curdelegation: 'Auftrag',
    hisdelegation: 'Auftragsverlauf',
    realtransaction: 'Markttransaktionen',
    num: 'Menge',
    price: 'Preis',
    direction: 'Richtung',
    time: 'Zeit',
    stall: 'Stand',
    total: 'Gesamt',
    traded: 'Erledigt',
    action: 'Aktion',
    undo: 'Rückgängig',
    delegationnum: 'Auftragsmenge',
    done: 'Erledigt',
    status: 'Status',
    finished: 'Abgeschlossen',
    canceled: 'Storniert',
    parted: "Teilweise",
    tip: 'Hinweis',
    buyamounttip: 'Kaufmenge eingeben',
    buyamounttipwarning: 'Kaufmenge nicht mehr als',
    success: 'Erfolgreich übermittelt!',
    pricetip: 'Kaufpreis eingeben',
    pricetipwarning: 'Kaufpreis nicht mehr als',
    sellamounttip: 'Verkaufsmenge eingeben',
    sellamounttipwarning: 'Verkaufsmenge nicht mehr als',
    sellpricetip: 'Verkaufspreis eingeben',
    sellpricetipwarning: 'Verkaufspreis nicht mehr als',
    undotip: 'Rückgängig machen bestätigen?',
    cancelsuccess: "Auftrag erfolgreich storniert",
    marketprice: 'Marktpreis',
    expand: {
        time: 'Zeit',
        price: 'Preis',
        amount: 'Menge',
        fee: 'Gebühr',
    },
    realtime: 'Echtzeit',
    kline: "KLine",
    depth: "Tiefe",
    open: "Öffnen",
    close: "Schließen",
    latestdeal: "Letzter Handel",
    myswapaccount: "Mein Swap-Konto",
    accountmode: "Modus",
    accountmargin: "Hebel",
    accountquanyi: "Eigenkapital",
    profitandloss: "Nicht realisierter G/V",
    principalAmount: "Verfügbare Margin",
    positionAmount: "Verwendete Margin",
    frozenAmount: "Gefrorene Margin",
    principalRate: "Margensatz",
    zijinhuazhuan: "Überweisung",
    up: "L",
    down: "S",
    canup: "Max. Long",
    candown: "Max. Short",
    cancloseup: "Max(Short)",
    canclosedown: "Max(Long)",
    openup: "Long eröffnen",
    opendown: "Short eröffnen",
    closeup: "Short schließen",
    closedown: "Long schließen",
    currentposition: "Offene Positionen",
    assetsdetail: "Transaktionen",
    marginMode1: "Isoliert",
    marginMode2: "Cross",
    modifyMarginModeTitle: "Kontomarginmodus ändern",
    modifyLeverage: "Hebel anpassen",
    moredetail: "Mehr anzeigen",
    shareNumber: "Kontrakt",
    entrustprice: "Preis",
    triggleprice: "Auslöser",
    openvolume: "Long-Volumen",
    closevolume: "Short-Volumen",
    triggleplaceholder: "Standardpreis ist Marktpreis",
    marketpriceplaceholder: "Wird zum besten Preis gehandelt",
    levmaxtip: "Der Hebel sollte nicht über dem Maximum liegen",
    levmintip: "Der Hebel sollte nicht unter dem Minimum liegen",
    marginModeSuccessTip: "Änderung erfolgreich.",
    noenoughbalance: "Unzureichendes Guthaben",
    pleaseinputopenvolume: "Das Volumen sollte über 0 liegen",
    pleaseinputcorrectopenvolume: "Bitte korrektes Volumen eingeben",
    pleaseinputrightentrustprice: "Bitte korrekten Preis eingeben",
    noenoughposition: "Unzureichende Position",
    pleaseinputclosevolume: "Das Volumen sollte über 0 liegen",
    pleaseinputcorrectclosevolume: "Bitte korrektes Volumen eingeben",
    pos_Pl: "G/V",
    pos_Ratio: "G/V-Quote",
    pos_pos: "Position",
    pos_canClose: "Verfügb. Position",
    pos_openPrice: "Eröffnungspreis",
    pos_leverage: "Hebel",
    pos_margin: "Aktuelle Margin",
    pos_mRatio: "Margensatz",
    pos_cmRatio: "Wartungssatz",
    pos_long: "Long",
    pos_short: "Short",
    ent_entrustType: "Öffnen/Schließen",
    ent_direction: "Richtung",
    ent_type: "Typ",
    ent_trigglePrice: "Auslösepreis",
    ent_entrustPrice: "Auftragspreis",
    ent_tradedPrice: "Handelspreis",
    ent_margin: "Margin",
    ent_volume: "Volumen",
    ent_status: "Status",
    ent_status1: "In Auftrag",
    ent_status2: "Storniert",
    ent_status3: "Auftrag fehlgeschlagen",
    ent_status4: "Gehandelt",
    ent_statusblast: "Liquidierung",
    ent_pl: "G/V",
    ent_fee: "Gebühr",
    triggerpriceshouldbigger: "Der Auslösepreis sollte über 0 liegen"
},
ctc: {
    title: "Ein-Klick-Verkauf ● Plattformgarantie ● Sicherheit",
    desc: "Krypto-Assets werden von BIPPAX verwaltet, und der Akzeptant bietet Austauschdienste für den Umtausch an.",
    buyin: "Kaufen",
    sell: "Verkaufen",
    buyprice: "Kaufpreis",
    sellprice: "Verkaufspreis",
    buynum: "Kaufmenge",
    sellnum: "Verkaufsmenge",
    payamount: "Zahlungsbetrag",
    getamount: "Erhaltener Betrag",
    avabalance: "Verfügbar",
    time: "Handelsdatum",
    tip: "Hinweis",
    notice: "Hinweis",
    notice1: "1. Der Bereich für den Legal-Tender-Handel ist ein Vermögensaustausch zwischen Nutzern und Akzeptanten. Die Mittel werden nicht auf die Plattform überwiesen, und die Plattform akzeptiert keine RMB-Aufladungen/Überweisungen;",
    notice2: "2. Die Akzeptanten des Legal-Tender-Handels haben die Echtheitsprüfung bestanden, bieten Transaktionsmargen an, und die Token werden von der Plattform verwaltet, sodass Sie sicher sein können, dass sie umgetauscht werden können;",
    notice3: "3. Die Servicezeit des Akzeptanten ist täglich von 09:00 bis 21:00. Die Annahme erfolgt innerhalb von 30 Minuten nach Eingang der Bestellung, und unausgeführte Transaktionen nach zwei Stunden werden storniert;",
    notice4: "4. Um Bankkarten im Bereich des Legal-Tender-Handels zu unterstützen, müssen Sie Mittel über ein Konto überweisen, das Sie mit Ihrer echten Identität authentifiziert haben;",
    notice5: "5. Um die Sicherheit der Transaktionsmittel zu gewährleisten, ist für den Legal-Tender-Handel eine Echtheitsprüfung der Nutzer erforderlich;",
    payType: "Zahlungskonto",
    receiveType: "Empfangskonto",
    moneyTips: "Der obige Preis dient nur als Referenz. Bitte beziehen Sie sich auf den tatsächlichen Abrechnungsbetrag nach der folgenden Bestellung.",
    verifyset: "Echtheitsprüfung/Asset-Passwort",
    payset: "Zahlungseinstellungen",
    trade: "Austausch",
    input50tips: "Bitte geben Sie eine Zahl zwischen 50 und 50.000 ein",
    bank: "Bankkarte",
    alipay: "Alipay",
    wechatpay: "WeChat",
    payaccountset: "Zahlungskontoeinstellungen",
    useselfaccount: "Bitte stellen Sie sicher, dass Sie ein mit Ihrer echten Identität authentifiziertes Konto verwenden.",
    orderSn: "Auftragsnummer",
    tradetime: "Austauschdatum",
    direction: "Richtung",
    amount: "Betrag (USDT)",
    money: "Gesamt (CNY)",
    price: "Preis (CNY)",
    status: "Status",
    operate: "Bearbeiten",
    moredetail: "Mehr Details"
},
cexchange: {
    title: "BZB Aktion",
    desc: "BZB Coin ● Ein-Klick ● Gewinn jeden Tag",
    quantity: "Aktivität - Kaufmenge",
    inputtips1: "Benutzerdefinierte Menge",
    choosecurrency: "Währung wählen",
    all: "Alle",
    totalpay: "Bezahlter Währungsbetrag",
    restricted: "Heutige Gesamtbeschränkung",
    currentprice: "Aktueller Preis",
    nextprice: "Nächster Ausgabepreis",
    confirmpay: "Zahlung bestätigen",
    assets: "Vermögenswerte:",
    loginFirst: "Bitte anmelden",
    success: "Herzlichen Glückwunsch, der Austausch war erfolgreich!",
    tip: "Tipps",
    confirm: "Bestätigungstipps",
    confirmmsg: "Möchten Sie BZB wirklich umtauschen?",
    ok: "OK",
    cancel: "Abbrechen"
},
subscribe: {
    Su1: 'Detailseite',
    Su2: 'Abonnement',
    Su3: 'Abonnement neuer Währungen',
    Su4: 'Noch nicht gestartet',
    Su5: 'Läuft',
    Su6: 'Wird bekannt gegeben',
    Su7: 'Entfernung',
    Su8: 'Start',
    Su9: 'Ausgabepreis',
    Su10: 'Erwartete Gewinn- und Verlustquote',
    Su11: 'Startzeit',
    Su12: 'Veröffentlichungszeit',
    Su13: 'Details',
    Su14: 'Abonnieren',
    Su15: 'Abonnementaufzeichnung',
    Su16: 'Währungsname',
    Su17: 'Ausgabepreis',
    Su18: 'Ausgabepreis',
    Su19: 'Anzahl der Gewinner',
    Su20: 'Rückerstattungsbetrag',
    Su21: 'Zeit',
    Su22: 'Status',
    Su23: 'Zeit',
    Su24: 'Abonnementbetrag',
    Su25: 'Abonnementwährung',
    Su26: 'Ausgabepreis',
    Su27: 'Erwarteter Gewinn und Verlust',
    Su28: 'Abonnementgrenze',
    Su29: 'Abonnementstartzeit',
    Su30: 'Abonnementendzeit',
    Su31: 'Zeit der Ergebnisveröffentlichung',
    Su32: 'Erwartete Startzeit',
    Su33: 'Abonnementbetrag',
    Su34: 'Währung',
    Su35: 'Abonnementbetrag',
    Su36: 'Abonnementzeit',
    Su37: 'Status',
    Su38: 'Noch nicht bekannt gegeben',
    Su39: 'Veröffentlicht',
    Su40: 'Projektinformationen',
    Su41: 'Verfügbares Guthaben',
    Su42: 'Sofort bewerben',
    Su43: 'Alle',
    Su44: 'Zahlungspasswort',
},
option: {
    minute: 'min',
    enter: 'Bitte eingeben',
    title: "Optionskontrakt",
    buyupreward: "Bull-Bonuspool",
    buydownreward: "Bear-Bonuspool",
    quantity: "Wettbetrag",
    myamount: "Mein Wettbetrag",
    buyup: "Bullisch",
    buydown: "Bärisch",
    history: "Verlauf",
    seriers: "Nr.",
    period: "",
    currentoption: "Zeitraum",
    openprice: "Eröffnungspreis",
    currentprice: "Aktueller Preis",
    openprice1: "Eröffnungspreis",
    closeprice: "Schlusspreis",
    opentime: "Eröffnungszeit",
    closetime: "Schließungszeit",
    progress: "Fortschritt",
    loginFirst: "Bitte zuerst anmelden!",
    selectAmount: "Bitte wählen Sie Ihren Betrag",
    balancenotenough: "Balance reicht nicht aus!",
    betsucceed: "Herzlichen Glückwunsch！Wette erfolgreich！",
    noopening: "Derzeit keine Öffnung!",
    col_createTime: "Erstellungszeit",
    col_direction: "Richtung",
    col_result: "Ergebnis",
    col_optionNo: "Nr.",
    col_betAmount: "Wettbetrag",
    col_rewardAmount: "Belohnungsbetrag",
    col_fee: "Einsatzgebühr",
    col_winfee: "Belohnungsgebühr",
    win: "Gewonnen",
    lose: "Verloren",
    wait: "Offen",
    avaliablebalance: "Verfügbares Guthaben",
    login: "Bitte anmelden",
    kline: "Echtzeit-Kurse",
    or1: 'Aktueller Preis',
    or2: 'Wettzeit',
    or3: 'Wettbetrag',
    or4: 'Wettwährung',
    or5: 'Anderer Betrag',
    or6: 'Der aktuelle Preis ist der Ausführungspreis',
    or7: 'Handelsgeschichte',
    or8: 'Quoten',
    or9: 'Bonus',
    or10: 'Handelsaufzeichnung',
    or11: 'Bitte wählen Sie 4 häufig verwendete USDT-Wetteinsätze',
},
otc: {
    ad: 'Werbung',
    buyin: 'Kaufen',
    sellout: 'Verkaufen',
    merchant: 'Händler',
    applymerchant: 'Händler werden',
    volume: 'Volumen',
    paymethod: 'Zahlungsmethode',
    amount: 'Betrag',
    price_coin: 'Preis / Coin',
    operate: 'Aktion',
    validate: 'Bitte zuerst verifizieren',
    sell: 'verkaufen',
    buy: 'kaufen',
    transaction: 'Handelstransaktionen',
    buttontxt: 'Händler werden',
    title: 'OTC-Handel',
    desc: 'Bequemer, sicherer und schneller Verkauf von digitalen Währungen',
    title1: 'Dynamische Anpassung',
    desc1: 'Echtzeit-Fluktuation gemäß Marktpreis',
    title2: 'Keine Gebühren',
    desc2: 'Was du siehst, ist was du bekommst. Abgesehen vom Verkaufspreis fallen keine Servicegebühren der Plattform an',
    title3: 'Sofortiger Handel',
    desc3: 'Einführung von Plattformdiensten für Händler, intelligente Abwicklung, Auftragsabschluss, kein Warten auf Matching',
    title4: 'Plattformgarantie',
    desc4: 'Plattform-zertifizierte Geschäfte, Sicherheit ist garantiert, 24/7 Kundenservice für den Handel',
    myad: {
        title: 'Meine Anzeigen',
        post: 'Anzeige erstellen',
        alert: '【Hinweis】: Wenn die Mindestanzahl für Werbekäufe plus die Gebühr größer ist als die verbleibende Anzahl der Anzeigen, wird die Anzeige automatisch aus dem Angebot genommen.',
        no: 'nein',
        type: 'Typ',
        sell: 'verkaufen',
        buy: 'kaufen',
        limit: 'Limit',
        remain: 'verbleibende Menge',
        coin: 'Coin',
        created: 'Erstellungsdatum',
        operate: 'Aktion',
        errmsg: 'Kann nach Entfernung der Anzeige bearbeitet und geändert werden',
        update: 'bearbeiten',
        shelf: 'Regal',
        dropoff: 'entfernen',
        delete: 'löschen',
    },
    myorder: 'Meine Bestellung',
    chatline: {
        status_1: 'Der Käufer hat noch nicht bezahlt und wartet auf die Zahlung des Käufers!',
        status_2: 'Der Käufer hat bezahlt und wartet darauf, dass der Verkäufer freigibt!',
        status_3: 'Auftrag abgeschlossen!',
        status_4: 'Auftrag wird angefochten!',
        status_5: 'Auftrag storniert!',
        loadmore: 'Mehr laden',
        warning: 'Betrugswarnung: In letzter Zeit haben Betrüger wiederholt Banküberweisungsinformationen und gefälschte Überweisungsnachweise für Betrug verwendet. Bitte überprüfen Sie unbedingt Ihre eigene Zahlungskontonummer. Stellen Sie die Sicherheit der Überweisungsgelder sicher und vermeiden Sie das Risiko, dass Ihre Bankkarten gesperrt werden!',
        contenttip: 'Bitte geben Sie den Chatinhalt ein. Drücken Sie die Eingabetaste, um zu senden',
        contentmsg: 'Nachricht darf nicht leer sein',
    },
    chat: {
        seller: 'Verkäufer',
        buyer: 'Käufer',
        exchangeamount: 'Austauschbetrag',
        operatetip: 'Betriebshinweis',
        operatetip_1: 'Bitte zahlen Sie innerhalb der Frist gemäß dem vom anderen Teil bereitgestellten Konto und klicken Sie auf dieser Seite.',
        finishpayment: 'Zahlung abgeschlossen',
        operatetip_1_1: 'Bitte beachten Sie bei der Überweisung die gute Zahlungsreferenznummer in den Kommentaren',
        operatetip_1_2: 'Nach Erhalt der Zahlung wird der Verkäufer die Zahlung auf der Website bestätigen. Das System sendet die von Ihnen gekauften digitalen Assets automatisch auf Ihr Konto. Bitte beachten Sie das',
        note: 'Hinweis',
        notetip: 'Bitte verwenden Sie keine anderen Chat-Software-Programme zur Kommunikation miteinander und nehmen Sie keine Dokumente, E-Mail-Anhänge usw. an, die Ihnen von der anderen Partei gesendet werden. Alle Kommunikationsverbindungen werden im Chatfenster auf dieser Seite abgeschlossen.',
        operatetip_2_1: 'Die digitalen Assets, die Sie verkauft haben, wurden der Plattform zur Verwahrung und Einfrierung übermittelt. Sie haben die Zahlung bestätigt, klicken Sie',
        operatetip_2_2: 'Glauben Sie keinem Grund, der die Freigabe der Währung drängt, bestätigen Sie den Erhalt des Geldes und geben Sie die digitalen Assets frei, um Verluste zu vermeiden!',
        operatetip_2_3: 'Nach Erhalt der Kurzmitteilung des Kontos loggen Sie sich bitte in das Online-Banking oder Mobile-Banking ein, um zu bestätigen, ob die Zahlung verbucht ist, um die Freigabe digitaler Assets aufgrund von betrügerischen Nachrichten zu vermeiden!',
        confirmrelease: 'Freigabe bestätigen',
        paydigital: 'Digitale Assets zahlen',
        orderstatus: 'Auftragsstatus',
        orderstatus_1: 'Zahlung abgeschlossen',
        orderstatus_2: 'Auftragsangebot',
        orderstatus_3: 'Freigabe bestätigen',
        orderstatus_4: 'Geschäft stornieren',
        orderstatus_5: 'Auftragsangebot',
        order: 'Auftrag',
        and: 'und',
        transition: 'Austausch',
        transprice: 'Handelspreis',
        transnum: 'Handelsmenge',
        transmoney: 'Handelsbetrag',
        tip1: 'Der Benutzer hat noch keine Bankkartenummer hinzugefügt',
        tip2: 'Der Benutzer hat vorübergehend kein Alipay-Konto hinzugefügt',
        tip3: 'Der Benutzer hat noch kein WeChat-Konto hinzugefügt',
        zfb: 'Alipay',
        wx: 'WeChat',
        qrcode: 'QR-Code',
        msg1: 'Sind Sie sicher, dass Sie gezahlt haben?',
        msg2: 'Zahlungen sind nicht rückerstattbar！Sind Sie sicher, dass Sie Ihren Auftrag stornieren möchten?',
        msg3: '【Wiederholung】: Zahlungen sind nicht rückerstattbar！Sind Sie sicher, dass Sie Ihren Auftrag stornieren möchten?',
        msg4: 'Bezahlt, nicht erhalten',
        msg5: 'Bereits bezahlt, nicht erhalten',
        tip: 'Hinweis',
        comptype: 'Beschwerdetyp',
        compremark: 'Beschwerdenotiz',
        willcomp: 'Ich möchte mich beschweren',
        msg6: 'Bestätigen Sie die Freigabe der Währung?',
        result_1: 'Warten auf Zahlung',
        result_2: 'Warten auf Freigabe',
        result_3: 'Abgeschlossen',
        result_4: 'Angebot',
        result_5: 'Storniert',
        msg7: 'Fonds-Passwort',
        msg7tip: 'Bitte geben Sie das Fonds-Passwort ein',
    },
    checkuser: {
        emaildone: 'E-Mail zertifiziert',
        emailundo: 'E-Mail nicht autorisiert',
        teldone: 'Telefonnummer zertifiziert',
        telundo: 'Telefonnummer nicht autorisiert',
        idcarddone: 'Personalausweis zertifiziert',
        idcardundo: 'Personalausweis nicht autorisiert',
        language: 'Sprache',
        languagetext: 'Chinesisch',
        registtime: 'Registrierungszeit',
        exchangetimes: 'Akku-mulierte Transaktionen',
        exchangeinfo: 'Handelsinformationen',
        tablabel1: 'Online verkaufen',
        tablabel2: 'Online kaufen',
        col_symbol: 'Coin',
        col_paymode: 'Zahlungsmethode',
        col_num: 'Betrag',
        col_price: 'Preis',
        col_created: 'Veröffentlichungszeit',
        col_operate: 'Aktion',
        operatemsg: 'Bitte führen Sie zuerst die Echtheitsprüfung durch',
        buyin: 'Kaufen',
        sellout: 'Verkaufen',
    },
    tradecenter: {
        postad: 'Anzeige erstellen',
        exchange: 'GCC-Transaktion',
        buyin: 'Ich möchte kaufen',
        sellout: 'Ich möchte verkaufen',
    },
    tradeinfo: {
        emaildone: 'E-Mail zertifiziert',
        emailundo: 'E-Mail nicht autorisiert',
        teldone: 'Telefonnummer zertifiziert',
        telundo: 'Telefonnummer nicht autorisiert',
        idcarddone: 'Personalausweis zertifiziert',
        idcardundo: 'Personalausweis nicht autorisiert',
        exchangetimes: 'Anzahl der Transaktionen',
        price: 'Preis',
        num: 'Betrag',
        paymethod: 'Zahlungsmethode',
        exchangelimitamount: 'Transaktionslimit',
        location: 'Ort',
        location_text: 'China',
        exchangeperiod: 'Transaktionszeitraum',
        minute: 'min',
        amounttip: 'Bitte geben Sie den Betrag ein',
        numtip: 'Bitte geben Sie die Nummer ein',
        remarktip: 'Sagen Sie ihm Ihre Anforderungen',
        remarktitle: 'Horizont-Bemerkungen',
        exchangetitle: 'Handelsinformationen',
        exchange_tip1: 'Nachdem Sie eine Transaktionsanfrage initiiert haben, wird die digitale Währung von der Plattform gehostet und geschützt. Wenn Sie ein Verkäufer sind, nachdem Sie eine Transaktionsanfrage initiiert haben, können Sie aufladen und auf die Zahlung des Käufers warten. Käufer zahlen innerhalb der Zahlungsfrist. Nach Erhalt der Zahlung sollten Sie die von Ihnen verwaltete digitale Währung freigeben.',
        exchange_tip2: 'Lesen Sie vor dem Handel die 《Plattform-Netzwerk-Nutzungsbedingungen》 und FAQs, Handbuch und andere Hilfedokumentationen.',
        exchange_tip3: 'Passen Sie auf Betrüger auf！Bevor Sie den Handel durchführen, überprüfen Sie bitte die Bewertung des Benutzers und achten Sie mehr auf neu erstellte Konten.',
        exchange_tip4: 'Bitte beachten Sie, dass Rundungen und Preisschwankungen den Betrag der letztendlich gehandelten digitalen Währung beeinflussen können. Der von Ihnen eingegebene feste Betrag bestimmt den endgültigen Betrag, und der digitale Währungsbetrag wird gleichzeitig mit dem aktuellen Wechselkurs berechnet, wenn die Anfrage gestellt wird.',
        exchange_tip5: 'Hosting-Dienste schützen sowohl Käufer als auch Verkäufer von Online-Transaktionen. Im Falle einer Streitigkeit werden wir alle bereitgestellten Informationen bewerten und die gehostete digitale Währung ihrem rechtmäßigen Eigentümer freigeben.',
        warning1: 'Geben Sie bis zu 2 Dezimalstellen ein',
        warning2: 'Auftragsbetrag ist',
        warning3: 'Geben Sie bis zu 8 Dezimalstellen ein',
        warning4: 'Die Auftragsmenge ist',
        confirmbuyin: 'Kauf bestätigen',
        confirmsellout: 'Verkauf bestätigen',
        buyin: 'Kaufen',
        sellout: 'Verkaufen',
        warning5: 'Bitte füllen Sie den Auftrag wie erforderlich aus',
    },
    publishad: {
        createad: 'Werbung erstellen',
        msg1: 'Wenn Sie häufig handeln, können Sie Ihre eigene Handelsanzeige erstellen. Wenn Sie nur gelegentlich handeln, empfehlen wir Ihnen, direkt zu suchen',
        msg2: 'Das Erstellen einer Handelsanzeige ist',
        msg3: 'Kostenlos',
        msg4: 'Wenn Sie die erstellten Anzeigen direkt bearbeiten möchten, überprüfen Sie bitte',
        tradead: 'Handelswerbung',
        myad: 'Meine Anzeige',
        iwant: 'Ich möchte',
        sellonline: 'Online verkaufen',
        buyonline: 'Online kaufen',
        exchangecoin: 'Währung tauschen',
        country: 'Land',
        currency: 'Coin',
        openfixedprice: 'Fixpreis öffnen',
        open: 'Öffnen',
        close: 'Schließen',
        usetip: 'Wenn aktiviert, wird der Preis Ihrer Währung nicht mit dem Markt schwanken und der Preis bleibt unverändert.',
        premiseprice: 'Prämie',
        premisepricetip: 'Bitte setzen Sie Ihre Prämie',
        fixedprice: 'Festpreis',
        fixedpricetip: 'Bitte geben Sie Ihren Austauschpreis ein',
        marketprice: 'Marktreferenzpreis',
        marketpricetip: 'Prämie bezieht sich auf den Prozentsatz, der über dem aktuellen Marktpreis liegt',
        exchangeprice: 'Austauschpreis',
        formual: 'Preisformel',
        num: 'Betrag',
        num_text1: 'Bitte geben Sie ein, was Sie möchten',
        num_text2: 'Nummer',
        exchangeperiod: 'Transaktionszeitraum',
        exchangeperiod_text1: 'Bitte geben Sie Ihre Handelsfrist ein',
        minute: 'min',
        tip1: 'Wie viel Zeit der Käufer für Transaktionen akzeptieren kann, bitte geben Sie eine ganze Zahl ein',
        tip2: '【Hinweis】Kann an persönliches Zentrum / Zahlungsmethode gebunden werden',
        tip3: 'Bitte geben Sie Ihren Mindesttransaktionsbetrag ein',
        tip4: 'Bitte geben Sie Ihren Maximaltransaktionsbetrag ein',
        tip5: 'Sie können Ihre besonderen Anforderungen in den Hinweisinformationen eingeben, z. B.: Anforderungen des Käufers, Online-Zeit usw.',
        paymode: 'Zahlungsmethode',
        minlimit: 'Mindesttransaktionsbetrag',
        maxlimit: 'Maximaltransaktionsbetrag',
        remark: 'Hinweise',
        openautoreply: 'Automatische Antwort öffnen',
        msg5: 'Wenn aktiviert, sendet das System automatisch die von Ihnen ausgewählte automatische Antwortphrase an die andere Partei, wenn der Benutzer über diese Anzeige eine Transaktion mit Ihnen initiiert.',
        autoreply: 'Automatische Antwort',
        autoreplytip: 'Nach Erhalt der Bestellung wird die Information automatisch an den Käufer zurückgegeben, z. B.: Zahlungsmethode, Sammelkonto usw.',
        fundpwd: 'Fonds-Passwort',
        fundpwdtip: 'Bitte geben Sie Ihr Fonds-Passwort ein',
        submit: 'Einreichen',
        warning1: 'Bitte geben Sie die richtige Zahl ein',
        warning2: 'Der Überlaufwert ist 0-20',
        warning3: 'Bitte geben Sie Ihren maximalen Transaktionsbetrag ein!',
        warning4: 'Bitte geben Sie eine ganze Zahl ein',
        warning5: 'Der maximale Transaktionsbetrag muss größer sein als der minimale Transaktionsbetrag!',
        warning6: 'Der maximale Transaktionsbetrag darf Ihren Gesamtverkaufsbetrag nicht überschreiten',
        warning7: 'Bitte geben Sie Ihren minimalen Transaktionsbetrag ein!',
        warning8: 'Der minimale Transaktionsbetrag muss größer oder gleich 100 sein!',
        warning9: 'Der minimale Transaktionsbetrag muss kleiner sein als der maximale Transaktionsbetrag',
        sellout: 'Verkaufen',
        buyin: 'Kaufen',
        inputtip1: 'Bitte geben Sie die Währung ein',
        inputtip2: 'Bitte geben Sie die richtige Option ein',
        inputtip3: 'Der Überlaufwert ist 0-20 und darf nicht 0 sein',
        inputtip4: 'Bitte geben Sie den richtigen Festpreis ein',
        inputtip5: 'Bitte geben Sie die richtige Zahl ein, und die maximale Anzahl der Transaktionen überschreitet nicht 100',
        inputtip6: 'Bitte geben Sie die richtige Handelsfrist ein',
        inputtip7: 'Bitte wählen Sie die Transaktionsmethode aus',
        inputtip8: 'Bitte geben Sie das Fonds-Passwort ein',
        zfb: 'Alipay',
        wx: 'WeChat',
        unionpay: 'UnionPay',
        submit_failure: 'Fehlgeschlagen!',
        submittip1: 'Bitte führen Sie eine Reihe von Zertifizierungen wie Echtheitsprüfung durch',
        submittip2: 'Bitte führen Sie eine Reihe von Zertifizierungen wie Mobiltelefon durch',
        submittip3: 'Bitte führen Sie eine Reihe von Zertifizierungen wie Fonds-Passwort durch',
        submittip4: 'Bitte binden Sie mindestens eine Zahlungsmethode an',
    },
    index: {
        title: 'Empfehlenswerte Werbung',
        exchangetimes: 'Transaktionsanzahl',
        exchangeprice: 'Transaktionspreis',
        exchangelimit: 'Transaktionslimit',
        paymode: 'Zahlungsmethode',
        buy: 'kaufen',
        sell: 'verkaufen',
        viewmore: 'Mehr',
        bot1: 'Sicher und zuverlässig',
        bot1_tip: 'Mehr als 10 Jahre Erfahrung im Finanzrisikomanagement-Team Anpassbares Sicherheitsrichtliniensystem',
        bot2: 'Schnell und einfach',
        bot2_tip: 'Peer-to-Peer-Benutzer-Handelsmodus kostenlos unterstützt Verschiedene Währungsaustauschkanäle',
        bot3: 'Volle Währung',
        bot3_tip: 'Auswahl der Haupt-digitale-Asset-Handelswährungen Mehr-Asset-Handelserfahrung',
        ibuy: 'Ich möchte kaufen',
        isell: 'Ich möchte verkaufen',
    }
},
activity: {
    all: "Alle",
    prepare: "Bald",
    ongoing: "Läuft",
    distributing: "Verteilung",
    completed: "Abgeschlossen",
    progress: "Fortschritt",
    totalsupply: "Gesamtversorgung",
    starttime: "Startdatum",
    endtime: "Enddatum",
    viewdetail: "Details",
    attend: "Teilnehmen",
    tokendistribute: "Token-Verteilung",
    baseinfo: "Aktivitätsinformationen",
    status: "Status",
    activitytype: "Aktivitätstyp",
    activitytype0: "Unbekannt",
    activitytype1: "Listung (FOF)",
    activitytype2: "Listung (AVA)",
    activitytype3: "Halte-Bonus",
    activitytype4: "Gratis-Kauf",
    activitytype5: "Mining-Kauf",
    activitytype6: "Gesperrt",
    ruledetail: "Regelwerk",
    publishprice: "Veröffentlichungspreis",
    activitycoin: "Aktivitäts-Token",
    accpetcoin: "Akzeptierte Währung",
    holdcoin: "Gehaltene Währung",
    limittimes: "Persönliche Teilnahmegrenze (Anzahl)",
    limitamount: "Persönliche Teilnahmegrenze (Betrag)",
    unlimited: "Unbegrenzt",
    alreadyamount: "Bereits verkaufte Menge",
    leftamount: "Verbleibende Menge",
    attention: "Hinweis",
    attentiontxt1: "1. Bei Teilnahme an [Warehouse-Splitting]- und [Gratis-Abonnement]-Aktivitäten werden die Vermögenswerte eingefroren, bis die Freigabe erfolgt.",
    attentiontxt2: "2. Bei Teilnahme an 'Halte-Bonus'- und 'Gratis-Kauf'-Aktivitäten kann die Anmeldung nicht mehr zurückgezogen werden.",
    attentiontxt3: "3. Falls die Aktivität aufgrund von Projektparteien oder höherer Gewalt abgesagt wird, werden die eingefrorenen Vermögenswerte auf das ursprüngliche Konto zurückgebucht.",
    attentiontxt4: "* Die endgültige Auslegung dieser Aktivität liegt bei BIPPAX.",
    inputamount: "Betrag eingeben",
    inputholdamount: "Einzuhaltende Menge eingeben",
    mybalance: "Verfügbares Guthaben",
    holdtips: "[Halte-Bonus] erfordert Sperrung bis zum Ende der Aktivität.",
    pleaseinputamount: "Bitte geben Sie einen Betrag ein!",
    pleaseinputholdamount: "Bitte geben Sie die einzuhaltende Menge ein!",
    commitfailed: "Einreichung fehlgeschlagen!",
    minlimitamountfailed: "Die Mindestmenge für den Tausch darf nicht unterschritten werden!",
    maxlimitamountfailed: "Die Tauschmenge darf die maximale Kaufmenge nicht überschreiten!",
    limittimesfailed: "Sie haben die maximale Teilnahmehäufigkeit überschritten!",
    balancenotenough: "Nicht genug Guthaben!",
    headertitledesc: "Offene Labs für eine gewinnbringende Zusammenarbeit zwischen Investoren, Projekten und Börsen",
    currentdivided: "Mein aktueller Anteil bringt mir",
    leveloneCount: "Grenze Ebene 1",
    submit: "Einreichen",
    tipsmobile: "Bitte verwenden Sie den PC (www.BIPPAX.com)",
    tipsmobile1: "Sie können über den PC teilnehmen.",
    intvalue: "Bitte geben Sie eine ganze Zahl ein",
    inputminingamount: "Anzahl der Käufe eingeben",
    moreactivity: "Mehr Aktivitäten",
    releaseType: "Freigabetyp",
    releaseType0: "Gleichmäßige Freigabe",
    releaseType1: "Isometrische Freigabe",
    lock: "Sperren",
    releaseDetail: "Freigabedetails",
    lockday: "Tage",
    lockweek: "Wochen",
    lockmonth: "Monate",
    lockyear: "Jahre",
    releasePercent: "Freigabeprozent",
    lockFee: "Sperrgebühr",
    releaseTimes: "Freigabehäufigkeit",
    times: "Male"
},
invite: {
    myinvitelink: "Mein Empfehlungslink",
    copy: "Kopieren",
    copyed: "Kopiert",
    mylevelone: "Ebene-1-Freunde",
    myleveltwo: "Ebene-2-Freunde",
    mycommission: "Kommissionseinkommen (USDT)",
    extrareward: "Zusätzliche Belohnungen",
    partnerlevel: "Partnerebene",
    ruledetail: "Regeldetails",
    ruleprofile1: "[Promotion Partner] bietet den höchsten Prozentsatz an lebenslanger Provision und ist die langfristigste Form der Rückvergütung. Wer sich aktiv einbringt, kann offizieller BIPPAX-Partner werden und vom gemeinsamen Wachstum profitieren. Die Details sind wie folgt:",
    ruleprofile2: "",
    ruleprofile3: "",
    ruleprofile4: "",
    ruletext1: "1. Um die Konzepte digitaler Assets zu verbreiten und die Nutzerbasis zu erweitern, hat BIPPAX das Programm „Promotion Partner“ eingeführt – gültig für immer.",
    ruletext2: "2. Es gibt zwei Empfehlungsebenen: Wenn A B empfiehlt, ist B A's Ebene-1-Freund. Wenn B C empfiehlt, ist C sowohl B's als auch A's Ebene-2-Freund.",
    ruletext3: "3. Neue Nutzer können nur über den direkten Link oder den Einladungscode des Empfehlenden als Ebene-1-Freunde registriert werden.",
    ruletext4: "4. Die Provision greift erst nach erfolgreicher Registrierung und Echtheitsprüfung des Empfehlungsempfängers.",
    ruletext5: "5. Die Dauer und Höhe der Provision hängt von der Anzahl der Ebene-1-Freunde ab. Je mehr Freunde, desto höher die Provision.",
    ruletext6: "6. Die Provision basiert auf den Handelsgebühren der empfohlenen Freunde (USDT, BTC, ETH).",
    ruletext7: "7. Die Rückvergütungsquote steigt mit der Anzahl der Ebene-1-Freunde. Die genauen Quoten sind:",
    ruletext8: "8. Die Top 10 bzw. 100 erhalten zusätzliche Boni von MKWORLDS.",
    ruletext9: "9. Bei Konflikten mit anderen Aktionen behalten sich BIPPAX Änderungen vor.",
    ruletext10: "10. Botschafter der Stufen L4 (Xunfu), L5 (Taishou) und L6 (Jiedushi) erhalten 5 %, 10 % bzw. 15 % der jährlichen Gesamtprovision.",
    ruletext11: "11. Die endgültige Auslegung liegt bei BIPPAX.",
    ruleexampletitle: "Beispiel:",
    ruleexamplecontent1: "Wenn Nutzerin Xiaoyan 100 Ebene-1-Freunde empfiehlt, die jeweils 5 Ebene-2-Freunde bringen, hat sie 100+500=600 Freunde. Bei einem täglichen Handel von 3000 CNY pro Person beträgt ihr monatliches Einkommen ca. 7200 CNY.",
    ruleexamplecontent2: "Bei 1000 Ebene-1- und 5000 Ebene-2-Freunden bei 3000 CNY Handel pro Tag: ca. 135.000 CNY/Monat.",
    lastupdate: "Zuletzt aktualisiert am",
    laststastic: "Zuletzt statistisch am",
    level: "Ebene",
    lv1: "Lizheng",
    lv2: "Xianling",
    lv3: "Zhifu",
    lv4: "Xunfu",
    lv5: "Taishou",
    lv6: "Jiedushi",
    levelonecount: "Anzahl Ebene 1",
    levelonecommission: "Rückvergütungsquote Ebene 1 / Gültigkeit",
    leveltwocommission: "Rückvergütungsquote Ebene 2 / Gültigkeit",
    partnerdivide: "Partner-Dividende",
    month: "Monate",
    alllife: "Lebenslang",
    totalcommissionrank: "Gesamtprovisionsrangliste",
    rank: "Rang",
    userid: "Nutzer-ID",
    rankday: "(Tag)",
    rankweek: "(Woche)",
    rankmonth: "(Monat)",
    rankall: "(Gesamt)",
    promotioncount: "Anzahl Empfehlungen",
    commissionusdt: "Provision (USDT)",
    ranktip1: "Die Liste sortiert nach der Gesamtprovision von Ebene-1-Freunden.",
    ranktip2: "Sortiert nach der Anzahl der Ebene-1-Empfehlungen.",
    thanks: "Danke für Ihre Unterstützung von BIPPAX!",
    headertip: "Diese Daten werden nicht in Echtzeit aktualisiert. Statistik alle 24 Stunden.",
    ptools: "Werbe-Tools",
    pt_title: "Kryptogeschenkkarte",
    pt_desc: "Eine Überraschung für Freunde, Familie, Kunden und Partner.",
    pt_more: "Mehr Tools kommen bald",
    pt_tips: "Gute Ideen? Schreiben Sie an promotion@BIPPAX.com – Belohnung möglich!",
    pt_card_amount: "Kartenwert",
    pt_card_deadline: "Frist",
    pt_card_noend: "Unbegrenzt",
    pt_card_btn: "30 Karten gratis bekommen (≈2000 CNY)",
    pt_card_btn_login: "Bitte zuerst anmelden",
    pt_card_rule: "Regeldetails",
    pt_card_summary: "Geschenkkarten helfen Partnern, offline Freunde zu werben. Wer eine Karte einlöst, wird automatisch Offline-Freund des Empfehlenden.",
    pt_card_rule1: "1. Maximal 30 kostenlose Karten pro Nutzer. Mehr benötigt manuelle Bestellung mit Anpassung.",
    pt_card_rule2: "2. Jede kostenlose Karte ist einmalig pro Nutzer. Auch bei unterschiedlichen Codes gilt: Nur eine Karte pro Nutzer einlösbar.",
    pt_card_rule3: "3. Ohne Einladungscode wird der Kartenempfänger automatisch Ebene-1-Freund des Ausstellers.",
    pt_card_rule4: "4. Geschenkkartenwerte sind 180 Tage gesperrt, danach freigegeben.",
    pt_card_rule5: "5. Echtheitsprüfung nicht erforderlich für Einlösung, aber für Umwandlung.",
    pt_card_rule6: "6. Endgültige Auslegung bei BIPPAX.PRO.",
    pt_card_day: "Tage",
    pt_card_title_tips: "Gratis-Werbegeschenk (≈2000 CNY)",
    pt_card_receivew_success: "Glückwunsch zur erfolgreichen Einlösung der Werbekarte!",
    usepromotion: "Werbematerialien nutzen",
    saveimage: "Bild speichern",
    imagetips: "Bei Download-Problemen: Bildschirmaufnahme verwenden!",
    pt_invite_title: "Einladungs-Leaflet",
    pt_invite_desc: "Per QR-Code automatisch Ebene-2-Freund. Ideal für Foren & Gruppen.",
    colum_text0: "Rang",
    colum_text1: "Mitglied",
    colum_text2: "Empfehlungen",
    colum_text3: "Provision (USDT)",
    colum_text4: "Zusatzbelohnung",
    context_title: "Exklusiver Code für Partner",
    context_title1: "Scannen für mehr Infos",
    context_title2: "Mein Einladungscode",
    context_title3: "Einladungsbild"
},
uc: {
    verify: "Zuerst KYC abschließen",
    login: {
        noaccount: 'Kein Konto?',
        register: 'Registrieren',
        login: 'Anmelden',
        welcomelogin: 'Willkommen',
        usertip: 'Bitte E-Mail eingeben',
        pwdtip: 'Passwort eingeben',
        validatecodeload: 'Verifizierungscode wird geladen',
        validatemsg: 'Bitte zuerst verifizieren',
        forget: 'Passwort vergessen?',
        loginvalidate: 'Bitte E-Mail oder Telefonnummer eingeben',
        pwdvalidate1: 'Bitte Passwort eingeben',
        pwdvalidate2: 'Passwort mindestens 6 Zeichen',
        success: 'Erfolg',
        goregister: "Registrieren",
        getlostpwd: "Passwort vergessen"
    },
    forget: {
        title: "Passwort vergessen",
        hasaccount: 'Hast du ein Konto? Anmelden',
        login: 'Anmelden',
        sendcode: 'Senden',
        newpwd: 'Neues Passwort eingeben',
        confirmpwd: 'Passwort wiederholen',
        save: 'Absenden',
        pwdvalidate1: 'Passwort bestätigen',
        pwdvalidate2: 'Passwörter stimmen nicht überein!',
        resettelpwd: 'Telefon-Passwort zurücksetzen',
        resetemailpwd: 'E-Mail-Passwort zurücksetzen',
        newpwdtip: 'Neues Passwort eingeben',
        pwdvalidate3: 'Mindestens 6 Zeichen',
        telno: 'Telefonnummer',
        mtelno: 'Telefon-Authentifizierung',
        memail: 'E-Mail-Authentifizierung',
        smscode: 'SMS-Code',
        teltip: 'Telefonnummer eingeben',
        smscodetip: 'SMS-Code eingeben',
        email: 'E-Mail',
        emailcode: 'E-Mail-Code',
        emailtip: 'E-Mail eingeben',
        emailcodetip: 'E-Mail-Code eingeben',
        resetpwdsuccess: 'Passwort erfolgreich zurückgesetzt',
        smswarn: 'Bitte auf SMS achten',
    },
    finance: {
        fi1: 'Kleine Beträge ausblenden',
        center: 'Finanzzentrum',
        personalassets: 'Währungsvermögen',
        swapassets: 'Swap-Vermögen',
        billdetail: 'Abrechnungsdetails',
        charge: 'Einzahlung',
        pickup: 'Auszahlung',
        tradetail: 'Handelsmining',
        paydividends: 'Dividenden',
        invitingmining: 'Einladungs-Belohnungen',
        money: {
            M1: 'Erhaltene Menge',
            M2: 'Überwiesene Menge',
            M3: 'Wechselkurs',
            cointype: 'Coin',
            balance: 'Guthaben',
            frozen: 'Gesperrtes Guthaben',
            operate: 'Aktion',
            charge: 'Einzahlung',
            pickup: 'Auszahlung',
            onkeytrans: "Überweisung",
            getaddress: 'Adresse abrufen',
            resetsuccess: 'Zurücksetzen erfolgreich',
            match: 'Abgleich',
            matchtip1: 'Verfügbares GCX-Matching',
            matchtip2: 'Menge eingeben',
            matcherr1: 'Bitte gültige Menge eingeben!',
            matcherr2: 'Maximale Menge überschritten!',
            matchsuccess: 'Abgleich erfolgreich!',
            needreleased: "Zu freigebende Vermögenswerte",
            totalassets: "Geschätzter Gesamtwert des Vermögens:"
        },
        swap: {
            totalassets: "Geschätzter Gesamtwert des Vermögens:",
            swap: " Swap",
            swaptype: 'SWAP',
            swapassets: "Kontoguthaben",
            avabalance: "Verfügbare Margin",
            usebalance: "Verwendete Margin",
            frozenbalance: "Gefrorene Margin",
            profitandloss: "Nicht realisierter Gewinn/Verlust",
            transfor: "Überweisung",
            inputtransferamount: "Überweisungsbetrag",
            all: "Alle",
            currencyaccount: "Spot-Konto",
            swapaccount: "Perpetual-Swap-Konto",
            clickchange: "Richtung ändern",
            avaamount: "Verfügbar",
            pleaseselectwallet: "Bitte Wallet auswählen",
            pleaseinputamount: "Bitte Betrag eingeben",
            oktransfer: "Jetzt überweisen"
        },
        trade: {
            start_end: 'Start-Ende',
            account_date: 'Kapital-Eingangsdatum',
            to: 'An',
            operatetype: 'Aktionstyp',
            search: 'Suchen',
            charge: 'Einzahlung',
            pickup: 'Auszahlung',
            transaccount: 'Überweisung',
            exchange: 'Exchange',
            otcbuy: 'OTC-Kauf',
            otcsell: 'OTC-Verkauf',
            activityaward: 'Aktivitätspreis',
            promotionaward: 'Werbebonus',
            dividend: 'Dividende',
            vote: 'Abstimmung',
            handrecharge: 'Manuelle Einzahlung',
            match: 'Matching',
            activitybuy: "Aktivitätskauf",
            ctcbuy: "C2C-Kauf",
            ctcsell: "C2C-Verkauf",
            chargetime: 'Auftragszeitpunkt',
            type: 'Typ',
            num: 'Menge',
            status: 'Status',
            finish: 'Abgeschlossen',
            fee: 'Mining-Rückzahlung',
            transactionTime: 'Handelszeit',
            symbol: 'Handelspaar',
            direction: 'Richtung',
            price: 'Preis',
            entrustment: 'Order',
            havedeal: 'Geschlossen',
            poundageAmount: 'Gebühr',
            exchangeOrderId: "Auftrags-ID",
            mineAmount: "Geförderte Währung (BHB)",
            buy: "KAUF",
            sell: "VERKAUF",
            limit: "LIMIT",
            market: "MARKT",
            clear: "Bedingungen löschen",
            turnover: "Umsatz"
        },
        paydividende: {
            money_holding: 'Guthaben-Dividende bereits erhalten (ETH): ',
            money_hold: 'Zu verteilende Dividende (ETH): ',
            paydividends: 'Dividende (ETH)',
            account_date: 'Kapital-Eingangsdatum',
            datehodld: 'Datum des Guthabens',
            start_end: 'Start-Ende',
            to: 'An',
            operatetype: 'Aktionstyp',
            search: 'Suchen',
            charge: 'Einzahlung',
            pickup: 'Auszahlung',
            transaccount: 'Überweisung',
            exchange: 'Exchange',
            otcbuy: 'OTC-Kauf',
            otcsell: 'OTC-Verkauf',
            activityaward: 'Aktivitätspreis',
            promotionaward: 'Werbebonus',
            dividend: 'Dividende',
            vote: 'Abstimmung',
            handrecharge: 'Manuelle Einzahlung',
            match: 'Matching',
            chargetime: 'Zeitpunkt',
            type: 'Typ',
            num: 'Menge',
            status: 'Status',
            finish: 'Abgeschlossen',
            fee: 'Gebühr',
            symbol: 'Coin-Symbol',
        },
        record: {
            Please: 'Bitte Suchzeitraum auswählen',
            start_end: 'Start-Ende',
            to: 'An',
            operatetype: 'Aktionstyp',
            search: 'Suchen',
            charge: 'Einzahlung',
            pickup: 'Auszahlung',
            transaccount: 'Überweisung',
            exchange: 'Exchange',
            otcbuy: 'OTC-Kauf',
            otcsell: 'OTC-Verkauf',
            activityaward: 'Aktivitätspreis',
            promotionaward: 'Werbebonus',
            dividend: 'Dividende',
            vote: 'Abstimmung',
            handrecharge: 'Manuelle Einzahlung',
            match: 'Matching',
            chargetime: 'Zeitpunkt',
            type: 'Typ',
            num: 'Menge',
            status: 'Status',
            finish: 'Abgeschlossen',
            fee: 'Gebühr',
            shouldfee: 'Fällige Gebühr',
            revenue: 'Einnahme-/Ausgabetyp',
            re1: 'Eingang',
            re2: 'Ausgang',
            discountfee: 'Abzug-Gebühr',
            realfee: 'Gebühr',
            symbol: 'Coin-Symbol',
            activitybuy: "Aktivitätskauf",
            ctcbuy: "C2C-Kauf",
            ctcsell: "C2C-Verkauf",
            redout: "RED-OUT",
            redin: "RED-IN",
            quickExchange: "Schneller Wechsel",
            currentRate: "Aktueller Kurs",
            from: "Von",
            inputexchangeamount: "Wechselbetrag eingeben",
            inputexchangepasswd: "Wechsel-Passwort eingeben",
            chooseTransCoinUnit: "Währung auswählen",
            inputTransAmount: "Menge auswählen",
            predictAmount: "Wird umgewandelt",
            qamount: "Menge",
            qrate: "Kurs",
            qexamount: "Umrechnungsbetrag",
            withdrawcodein: "WithdrawCode-Einzahlung",
            withdrawcodeout: "WithdrawCode-Auszahlung",
            contractfee: "Swap-Gebühr",
            contractprofit: "Swap-Gewinn",
            contractloss: "Swap-Verlust",
            optionfail: "Option fehlgeschlagen",
            optionfee: "Option-Gebühr",
            optionreward: "Option-Belohnung",
            other: "Sonstiges"
        },
        recharge: {
            recharge: 'Einzahlung',
            symbol: 'Coin',
            address: 'Einzahlungsadresse',
            copy: 'Kopieren',
            qrcode: 'QR-Code',
            qrcodeaddress: 'Einzahlungs-QR-Code',
            msg1: 'Nur die entsprechende Währung einzahlen!',
            msg2: 'Nach Einzahlung: 2 Netzwerkbestätigungen, dann 6 für Auszahlung.',
            msg3: 'Mindesteinlage: ',
            msgtop: 'Nur für Einzahlungen',
            msg3_1: ", kleinere Beträge werden nicht gutgeschrieben.",
            msg4: 'Die Adresse ändert sich selten. Bei Änderungen benachrichtigen wir Sie.',
            msg5: 'Bitte beachten Sie die Sicherheit Ihres Computers!',
            record: 'Verlauf',
            copysuccess: 'Erfolg!',
            copyerr: 'Fehler, bitte manuell kopieren',
            time: 'Eingangszeit',
            amount: 'Betrag',
            gettingaddress: "Einzahlungsadresse wird geladen...",
            getaddress: "Einzahlungsadresse abrufen",
            memotips: "Bitte Memo eingeben, sonst gehen Vermögenswerte verloren!",
            withdrawrecharge: "Einzahlung per Code",
            coderechargetip: "Einzahlungscode eingeben",
            rechargesuccess: "Einzahlung erfolgreich!",
            rechargeconfirm: "Einzahlung bestätigen",
            status: "Status"
        },
        withdraw: {
            pickup: 'Auszahlung',
            addressmanager: 'Adressverwaltung',
            withdrawbycode: 'Auszahlung per Code',
            withdrawcode: 'Auszahlungscode',
            symbol: 'Coin',
            address: 'Adresse',
            num: 'Betrag',
            avabalance: 'Verfügbares Guthaben',
            msg1: 'Mindestbetrag: ',
            msg2: 'Automatisch oder manuell freigegeben',
            increase: 'Kredit erhöhen',
            tip1: 'Maximal ',
            tip11: 'Dezimalstellen, Mindestwert: ',
            tip2: 'Maximalwert: ',
            numtip1: 'Münzmenge eingeben',
            fee: 'Gebühren',
            range: 'Bereich',
            arriamount: 'Eingetroffene Menge',
            msg3: 'Mindestmenge: ',
            msg4: 'Währung',
            msg5: 'Manuelle Prüfung bei Änderungen.',
            msg6: 'Bitte Sicherheit beachten!',
            record: 'Auszahlungsverlauf',
            symboltip: 'Währung auswählen',
            addresstip: 'Adresse eingeben',
            numtip2: 'Gültige Münzmenge, Mindestwert: ',
            numtip3: 'Mindestbetrag über Gebühr',
            amounttip: 'Betrag eingeben',
            feetip1: 'Mindestgebühr: ',
            feetip2: 'Maximalwert: ',
            time: 'Auszahlungszeit',
            status: 'Status',
            status_1: 'In Prüfung',
            status_2: 'In Überweisung',
            status_3: 'Fehlgeschlagen',
            status_4: 'Erfolgreich',
            St5: 'Geschätzter Kurs',
            St6: 'Gesamtvermögen = Wallet + Unrealisiert',
            St7: 'Unrealisierter Gewinn/Verlust',
            St8: 'Wallet = Einzahlungen - Auszahlungen - Realisierte Gewinne',
            St9: 'Abgelehnt',
            remark: 'Bemerkung',
            add: 'Hinzufügen',
            addresslist: 'Adressliste',
            safevalidate: 'Sicherheitsprüfung',
            telno: 'Telefon',
            mtelno: 'Telefonprüfung',
            memail: 'E-Mail-Prüfung',
            smscode: 'SMS-Code',
            second: 'Sekunde',
            clickget: 'Abrufen',
            email: 'E-Mail',
            emailcode: 'E-Mail-Code',
            save: 'Speichern',
            delete: 'Löschen',
            telerr: 'Falsche Telefonnummer',
            emailerr: 'Falsche E-Mail',
            codeerr: 'Falscher Code',
            remarktip: 'Bemerkung eingeben',
            savemsg1: 'Speichern fehlgeschlagen!',
            savemsg2: 'Erfolgreich gespeichert!',
            operate: 'Aktion',
            fundpwdtip: 'Fonds-Passwort eingeben',
            click: 'Klicken',
            filtrate: 'Filtern',
            txid: "TxId",
            generateCode: "Auszahlungscode generieren",
            withdrawcodelist: "Auszahlungscode-Liste",
            withdrawcodestatus: "Status",
            submit: "Einreichen",
            generatecodesuccess: "Auszahlungscode erstellt!",
            wi1: 'Netzwerk',
            wi2: 'Sicherheitsprüfung',
            wi3: 'Eingegangener Betrag',
            wi4: 'Empfangsadresse',
            wi5: 'Auszahlungsnetzwerk',
            wi6: 'Gesamtbetrag',
            wi7: 'Netzwerkgebühr',
            wi8: 'Bitte Adresse und Netzwerk prüfen',
            wi9: 'Nicht stornierbar',
            wi10: 'Weiter',
            wi11: 'Fonds-Passwort',
            wi12: 'Telefon-Code',
            wi13: 'Senden',
            wi14: 'Code',
            wi15: 'Senden',
            wi16: 'Einreichen',
        }
    },
    member: {
        usercenter: "Benutzerprofil",
        securitycenter: 'Sicherheitszentrum',
        securitysetting: 'Sicherheitseinstellungen',
        accountsetting: 'Kontoeinstellungen',
        account: "Konto",
        assets: "Finanzen",
        exchange: "Exchange",
        curdelegate: "Aktueller Auftrag",
        hisdelegate: "Auftragsverlauf",
        otc: "OTC"
    },
    order: {
        ordercenter: 'Auftragszentrum',
        myorder: 'Meine Bestellungen',
        myad: 'Meine Anzeigen'
    },
    regist: {
        Res1: 'Nutzername: Buchstaben, Zahlen, mindestens ein Buchstabe',
        hasaccount: 'Hast du ein Konto? Anmelden',
        login: 'Anmelden',
        username: 'Nutzername',
        country: 'Land',
        smscode: 'SMS-Code',
        sendcode: 'Senden',
        resendcode: "Erneut senden (",
        pwd: 'Passwort',
        repwd: 'Passwort wiederholen',
        confrimpwd: 'Passwort bestätigen',
        agreement: 'Ich habe die Nutzungsbedingungen gelesen und stimme zu',
        userprotocol: 'Nutzungsvereinbarung',
        regist: 'Registrieren',
        teltip: 'Telefonnummer eingeben',
        telerr: 'Falsches Format',
        emailtip: 'E-Mail eingeben',
        emailerr: 'Falsches Format',
        confirmpwdtip: 'Passwort bestätigen',
        confirmpwderr: 'Passwörter stimmen nicht überein!',
        telregist: 'Telefon-Registrierung',
        emailregist: 'E-Mail-Registrierung',
        usernametip: 'Nutzername eingeben',
        usernamemsg: '3–15 Zeichen',
        countrytip: 'Land auswählen',
        smscodetip: 'SMS-Code eingeben',
        pwdtip: 'Passwort eingeben',
        pwdmsg: 'Mindestens 6 Zeichen',
        telno: 'Telefon',
        email: 'E-Mail',
        agreementtip: 'Hier klicken zum Akzeptieren',
        modaltitle: 'Bitte verifizieren',
        promotion: 'Einladungscode',
        china: 'China',
        singapore: 'Singapur',
        korea: 'Korea',
        japan: 'Japan',
        thailand: 'Thailand',
        russia: 'Russland',
        uk: 'UK',
        vietnam: 'Vietnam',
        india: 'Indien',
        italy: 'Italien',
        hk: 'HK',
        malaysia: 'Malaysia',
        taiwan: 'Taiwan',
        turkey: 'Türkei',
        germany: 'Deutschland',
        france: 'Frankreich',
        spain: 'Spanien',
        us: 'USA'
    },
    safe: {
        beneficiaryTitle: 'Informationen zum Begünstigten',
        beneficiaryEmpty: 'Es wurden noch keine Angaben zum Begünstigten hinterlegt',
        beneficiaryName: 'Name des Begünstigten',
        beneficiaryIdNumber: 'Ausweisnummer des Begünstigten',
        beneficiaryMobilePhone: 'Mobiltelefon des Begünstigten',
        beneficiaryNamePlaceholder: 'Bitte geben Sie den Namen des Begünstigten ein',
        beneficiaryIdPlaceholder: 'Bitte geben Sie die Ausweisnummer des Begünstigten ein',
        beneficiaryMobilePlaceholder: 'Bitte geben Sie die Mobiltelefonnummer des Begünstigten ein',
        beneficiaryTip: 'Dient zum Erfassen und Ändern des Namens, der Ausweisnummer und der Mobiltelefonnummer des Begünstigten.',
        beneficiaryNameRequired: 'Bitte geben Sie den Namen des Begünstigten ein',
        beneficiaryNameInvalid: 'Der Name des Begünstigten muss 2 bis 30 Zeichen lang sein',
        beneficiaryIdRequired: 'Bitte geben Sie die Ausweisnummer des Begünstigten ein',
        beneficiaryIdInvalid: 'Das Format der Ausweisnummer des Begünstigten ist ungültig',
        beneficiaryMobileRequired: 'Bitte geben Sie die Mobiltelefonnummer des Begünstigten ein',
        beneficiaryMobileInvalid: 'Das Format der Mobiltelefonnummer des Begünstigten ist ungültig',
        Ad1: 'Bitte laden Sie Ihre Sozialversicherungskarte, Ihren Führerschein oder Reisepass hoch',
        Ad2: 'Laden Sie eine der Dateien vor dem Absenden hoch',
        Ad3: 'Vollständiger Name',
        Ad4: 'Kontaktadresse',
        Ad5: 'Live-Übertragung',
        Ad6: 'Mein Live',
        Ad7: 'Hinzufügen fehlgeschlagen, maximal 3 können hinzugefügt werden',
        size: 'Die Größe des hochgeladenen Bildes darf 5 MB nicht überschreiten',
        safelevel_low: 'Sicherheitsstufe: Niedrig',
        safelevel_high: 'Sicherheitsstufe: Hoch',
        safelevel_medium: 'Sicherheitsstufe: Mittel',
        nickname: 'Spitzname',
        bind: 'Binden',
        binded: 'Gebunden',
        verifypass: "Verifiziert",
        binding: 'Wird gebunden',
        binderr: 'Fehlgeschlagen',
        bindretry: 'Wiederholen',
        verified: 'Verifiziert',
        notverified: "Nicht verifiziert",
        verifiedtip: 'Um die Sicherheit Ihres Kontos zu schützen, führen Sie bitte die Echtnamen-Verifizierung durch, bevor Sie handeln!',
        realname: 'Echter Name',
        idcard: 'Ausweis',
        upload: 'Hochladen',
        upload_positive: 'Vorderseite des Ausweises hochladen',
        upload_negative: 'Rückseite des Ausweises hochladen',
        upload_hand: 'Handgehaltenes Ausweisfoto hochladen',
        save: 'Speichern',
        reset: 'Zurücksetzen',
        email: 'E-Mail',
        bindemail: 'E-Mail binden',
        loginpwd: 'Login-Passwort',
        emailcode: 'E-Mail-Bestätigungscode',
        clickget: 'Zum Erhalten klicken',
        second: 'Sek.',
        phone: 'Telefon',
        bindphone: 'Telefon binden',
        phonecode: 'Telefon-Bestätigungscode',
        logintip: 'Wird beim Login auf der Plattform verwendet',
        edit: 'Bearbeiten',
        oldpwd: 'Altes Login-Passwort',
        newpwd: 'Neues Login-Passwort',
        confirmnewpwd: 'Neues Passwort bestätigen',
        fundpwd: 'Finanzpasswort',
        fundtip: 'Bei Änderungen am Kontoguthaben ist die Eingabe des Finanzpassworts erforderlich',
        set: 'Festlegen',
        confirmpwd: 'Passwort bestätigen',
        oldfundpwd: 'Altes Finanzpasswort',
        newfundpwd: 'Neues Finanzpasswort',
        newpwdmsg1: 'Bitte geben Sie mindestens 6 Zeichen für das neue Login-Passwort ein',
        newpwdmsg2: 'Neues Login-Passwort stimmt nicht überein',
        pwdmsg1: 'Bitte geben Sie mindestens 6 Zeichen für das Passwort ein',
        pwdmsg2: 'Passwörter stimmen nicht überein',
        emailtip: 'Bitte E-Mail eingeben',
        codetip: 'Bitte Bestätigungscode eingeben',
        telnotip: 'Bitte Telefonnummer eingeben',
        oldpwdtip: 'Bitte das ursprüngliche Passwort eingeben',
        realnametip: 'Bitte echten Namen eingeben',
        idcardtip: 'Bitte Ausweisnummer eingeben',
        bindphonetip: 'Bitte zuerst Telefon binden!',
        resetfundpwd: 'Finanzpasswort zurücksetzen',
        upload_positivetip: 'Bitte Vorderseite des Ausweises hochladen',
        upload_negativetip: 'Bitte Rückseite des Ausweises hochladen',
        upload_handtip: 'Bitte handgehaltenes Ausweisfoto hochladen',
        save_success: 'Erfolg!',
        save_failure: 'Fehlgeschlagen!',
        imgtip: 'Bitte laden Sie Ihren QR-Code zum Empfang von Bargeld hoch',
        idcard_verifymsg1: "1. Die Datei ist kleiner als 8 MB. Die Informationen auf dem Dokument müssen klar erkennbar sein, keine Änderungen oder Abdeckungen, Dokumentnummer und Name müssen sichtbar sein.",
        idcard_verifymsg2: "2. Das Foto sollte Sie ohne Hut zeigen. Es wird empfohlen, kein Make-up zu tragen. Die Gesichtszüge und die Arme des Dokumentinhabers müssen klar erkennbar sein.",
        idcard_verifymsg3: "3. Sie müssen sowohl das Dokument als auch eine handschriftliche Notiz (Name + Antragsdatum) halten: 'Alle meine Handlungen auf dieser Seite sind meine eigenen, ich verstehe die Risiken und bin bereit, alle rechtlichen Konsequenzen für dieses Konto zu tragen.'"
    },
    account: {
        pagetitle: 'Echtnamenkonto binden',
        pagetip: 'Bitte richten Sie Ihre Zahlungsmethode ein und verwenden Sie unbedingt Ihr Echtnamenkonto',
        backcardno: 'Bankkonto',
        backcardtip: 'Persönliche Bankkarteninformationen sind nicht gebunden',
        modify: 'Bearbeiten',
        bind: 'Binden',
        name: 'Name',
        bankaccount: 'Bankkonto',
        bankbranch: 'Bankfiliale',
        bankno: 'Banknummer',
        confirmbankno: 'Kartennummer bestätigen',
        fundpwd: 'Finanzpasswort',
        save: 'Speichern',
        zfbaccount: 'Alipay-Konto',
        zfbaccounttip: 'Persönliches Alipay-Konto ist nicht gebunden',
        wxaccount: 'WeChat-Konto',
        wxaccounttip: 'Persönliches WeChat-Konto ist nicht gebunden',
        banknomsg1: 'Bitte geben Sie die korrekte Bankkartennummer ein',
        banknomsg2: 'Die zweimal eingegebene Bankkartennummer stimmt nicht überein!',
        verifiedmsg: 'Bitte führen Sie zuerst die Echtnamen-Verifizierung durch',
        bankaccountmsg: 'Bitte wählen Sie Ihre Bank aus',
        bankbranchmsg: 'Bitte geben Sie die Filiale ein',
        banknomsg: 'Bitte geben Sie die korrekte Bankkartennummer ein',
        fundpwdmsg1: 'Bitte geben Sie das korrekte Finanzpasswort ein',
        fundpwdmsg2: 'Passwort darf nicht weniger als 6 Zeichen haben',
        zfbaccountmsg: 'Bitte Alipay-Konto eingeben',
        wxaccountmsg: 'Bitte WeChat-Konto eingeben',
        save_success: 'Erfolg!',
        save_failure: 'Fehlgeschlagen!',
    },
    otcorder: {
        unpaid: 'Unbezahlt',
        paided: 'Bezahlt',
        finished: 'Abgeschlossen',
        canceled: 'Storniert',
        appealing: 'In Prüfung',
        searchtip: 'Bitte Bestellnummer eingeben',
        orderno: 'Bestellnr.',
        created: 'Zeit',
        symbol: 'Coin',
        type: 'Typ',
        type_sell: 'Verkaufen',
        type_buy: 'Kaufen',
        tradename: 'Handelsname',
        amount: 'Menge',
        money: 'Betrag',
        fee: 'Gebühr',
    },
    identity: {
        certified: "bereits verifiziert",
        placeholder: "Bitte geben Sie den Stornierungsgrund an",
        apply: 'Als Unternehmen bewerben',
        become: "Werden Sie BIPPAX-zertifiziertes Unternehmen und genießen Sie mehr Handelsprivilegien",
        zhusnhu: "Unternehmen erhalten exklusive Werbeplätze zur Steigerung des Transaktionserfolgs",
        tijiaoziliao: "Händler-Authentifizierungsinformationen einreichen",
        place: "Bitte laden Sie die vorbereiteten Authentifizierungsunterlagen hoch und reichen Sie sie ein",
        tijiao: "Ihr Antrag auf Händlerzertifizierung wurde eingereicht",
        tijiaosuc: "Glückwunsch, Ihre Händlerzertifizierung wurde genehmigt",
        tijiaofail: "Leider wurde Ihre Händlerzertifizierung nicht genehmigt",
        zhuxiaotijiao: "Ihr Antrag auf Geschäftsauflösung wurde eingereicht",
        shenhefail: "Ihr Antrag auf Geschäftsauflösung wurde nicht genehmigt",
        shenhesuc: "Ihr Antrag auf Geschäftsauflösung wurde genehmigt",
        shangjiazhuxiao: "Geschäftsauflösung",
        shenagain: "Erneut prüfen",
        shenheshibai: "Prüfung fehlgeschlagen",
        sheqinggain: "Erneut beantragen",
        reason: "Grund",
        shenqingtuibao: "Kredit beantragen",
        getquan: "Sie haben folgende Berechtigungen",
        read: "Ich habe gelesen und stimme zu",
        lijishenqing: "Jetzt bewerben",
        tips: "Hinweis",
        wufachexiao: "Sie führen eine Geschäftsauflösung durch. Nach Bestätigung kann der Vorgang nicht widerrufen werden.",
        suredo: "Sind Sie sicher, dass Sie dies tun möchten?",
        shuzizichan: "Zertifikat für digitalen Vermögenshandel",
        gerenzichan: "Persönliches Zertifikat für digitale Vermögenswerte",
        second: {
            line: "Wie bewerbe ich mich als Unternehmen?",
            step1: "Schritt 1: Benötigte Unterlagen vorbereiten",
            step1c1: "Folgende Unterlagen vorbereiten:",
            step1c2: "Handynummer, WeChat-ID, QQ-Nummer, persönliches Zertifikat für digitale Vermögenswerte (Bild), Zertifikat für digitalen Vermögenshandel (Bild)",
            step2: "Schritt 2: Antrag einreichen",
            step2c: "Füllen Sie die erforderlichen Unterlagen aus und laden Sie sie hoch, dann auf 'Einreichen' klicken.",
            step3: "Schritt 3: Datenprüfung",
            stepc: "Wir prüfen Ihren Antrag innerhalb von drei bis fünf Tagen. Nach Genehmigung können Sie Anzeigen im Bereich für Fiat-Währung veröffentlichen.",
            agree: "Einverstanden mit Einfrieren",
            agreec: "Als Händlerkaution",
            shenqingchngweishangjia: "Als Unternehmen bewerben",
        },
        yuanyin: "Grund",
        bizhong: "Einzahlungswährung",
        shuliang: "Margin-Betrag",
        chosen: "Währung auswählen",
        seat: 'Exklusiver Stand',
        service: 'Individueller Service',
        lowfee: 'Niedrigere Gebühren',
        phone: 'Telefon',
        balance: 'Persönliche Vermögenswerte',
        cardphoto: 'Vorder- und Rückseite des Ausweises',
        wx: 'WeChat',
        exchange: 'Außerbörslicher Handel mit digitalen Vermögenswerten',
        handphoto: 'Benutzer hält Ausweisfoto',
        qq: 'QQ',
        ploy: 'Gibt es eine entsprechende Risikokontrollstrategie',
        agreement: '《Zertifizierte Händlervereinbarung》',
        applyfor: 'Bewerben',
        sendcode: 'Senden',
        confirm: 'Bestätigen',
        prepare: 'Unterlagen vorbereiten',
        result: "Auf Ergebnis warten",
        review: 'Zur Prüfung einreichen',
        passed: 'Prüfung bestanden',
        approve: 'Bitte stimmen Sie der Händlervereinbarung zu',
        emailtip1: 'Bitte senden Sie die folgenden Unterlagen an',
        emailtip2: 'Wir prüfen Ihren Antrag so schnell wie möglich.',
    },
    extension: {
        title1: 'Promotion-Links',
        title2: 'Empfohlene Freunde',
        title3: 'Meine Provision',
        linkdesc: 'Die folgende URL ist Ihre Adresse zur externen Promotion. Sie können sie über Freunde, QQ, WeChat, Weibo, Blogs, Foren oder Ihre eigene Website verbreiten. Alle, die sich über diesen Link registrieren, werden Ihre Nutzer. Wenn diese Nutzer Strategien auf dieser Seite einreichen, erhalten Sie Provisionen. Details finden Sie im Zugriffsprotokoll.',
        linktitle: 'Ihre Promotion-Links',
        copy: 'Kopieren',
        copy_msg1: 'Erfolgreich kopiert!',
        copy_msg2: 'Fehlgeschlagen! Bitte manuell kopieren',
        username: 'Name',
        currrecharge: 'Transaktion',
        userlevel: 'Benutzerlevel',
        createdtime: 'Registrierungszeit',
        currcommission: 'Aktuelle Provision',
        managerfee: 'Verwaltungsgebühr',
        yuan: 'Yuan (RMB)',
        symbol: 'COIN',
        amount: 'Betrag',
        remark: 'Bemerkung',
        amounttime: 'Lieferzeit',
    },
    promotion: {
        title: "Promotion-Center",
        subtitle1: "Meine Karten",
        subtitle2: "Umtauschverlauf",
        subtitle3: "Meine Promotion",
        card_column0: "Umtauschcode",
        card_column1: "Name",
        card_column2: "Coin-Symbol",
        card_column3: "Betrag",
        card_column4: "Ablaufdatum",
        card_column5: "Gesamt",
        card_column6: "Eingelöst",
        card_column7: "Erstellungszeit",
        my_column0: "Eingeladener Nutzer",
        my_column1: "Registrierungsdatum",
        my_column2: "Echter Name",
        gopromotion: "Promotion",
        inputcardno: "Bitte Kartencode eingeben",
        exchange: "Umtauschen",
        exchangesuccess: "Glückwunsch! Sie können das Asset im Finanzcenter einsehen!",
        exchangewithcode: "Mit Code umtauschen"
    },
    activity: {
        navTitle: "Innovation",
        subNavTitle1: "Meine Bestellungen",
        subNavTitle2: "Mein Mining",
        subNavTitle3: "Meine Sperrungen",
        column1: "Name",
        column2: "Typ",
        column3: "Betrag",
        column4: "Einheit (IN)",
        column5: "Einheit (OUT)",
        column6: "Status",
        column7: "Umsatz",
        column8: "Erstellungszeit",
        mColumn1: "Bild",
        mColumn2: "Name",
        mColumn3: "Coin-Einheit",
        mColumn4: "Zeitraum",
        mColumn5: "Mining-Tage",
        mColumn6: "Bereits geminte Tage",
        mColumn7: "Status",
        mColumn8: "Basis-Kapazität",
        mColumn9: "Aktuelle Kapazität",
        mColumn10: "Insgesamt gemint",
        mColumn11: "Enddatum",
        mColumn12: "Erstellungsdatum",
        lColumn1: "Bild",
        lColumn2: "Name",
        lColumn3: "Coin-Einheit",
        lColumn4: "Zeitraum",
        lColumn5: "Gesperrte Tage",
        lColumn6: "Freigegebene Tage",
        lColumn7: "Status",
        lColumn8: "Basis-Kapazität",
        lColumn9: "Aktuelle Kapazität",
        lColumn10: "Insgesamt freigegeben",
        lColumn11: "Enddatum",
        lColumn12: "Erstellungsdatum",
    },
    mining: {
        title: "Meine Mining-Liste",
        empty: "Keine Einträge",
        day: "Tag",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
        invitetip1: "Die Kapazität der Mining-Maschine kann durch das Einladen von Freunden erhöht werden. Jede eingeladene Person, die die Mining-Maschine tauscht, erhöht die Kapazität um ",
        invitetip2: "Obergrenze der Kapazitätserhöhung ",
        miningUnit: "Mining-Einheit",
        miningPeriod: "Mining-Zeitraum",
        miningDays: "Mining-Zeiten",
        miningedDays: "Geminte Zeiten",
        miningDaysProfit: "Basis-Ertrag",
        miningCurrentDaysProfit: "Aktueller Ertrag",
        status0: "Bereit zur Bereitstellung",
        status1: "Bereitgestellt",
        status2: "Beendet"
    },
    locked: {
        title: "Meine Sperrliste",
        empty: "Keine Einträge",
        day: "Tag",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
        invitetip1: "Die Kapazität der Sperrung kann durch das Einladen von Freunden erhöht werden. Jede eingeladene Person, die die Sperrung tauscht, erhöht die Kapazität um ",
        invitetip2: "Obergrenze der Kapazitätserhöhung ",
        miningUnit: "Freigabe-Einheit",
        miningPeriod: "Freigabe-Zeitraum",
        miningDays: "Freigabe-Zeiten",
        miningedDays: "Freigegebene Zeiten",
        miningDaysProfit: "Basis-Ertrag",
        miningCurrentDaysProfit: "Aktueller Ertrag",
        status0: "Bereit zur Freigabe",
        status1: "Freigabe läuft",
        status2: "Beendet",
        totallocked: "Gesamt gesperrt"
    },
    api: {
        apiAdmin: "API-Verwaltung",
        createApi: "Neuen API-Schlüssel erstellen",
        mark: "Bemerkung",
        bindAddress: "Der nicht gebundene IP-Adressschlüssel ist 90 Tage gültig",
        hint: 'Hinweis',
        part1: "Wir bieten Ihnen eine leistungsstarke API, mit der Sie Marktabfragen, automatische Transaktionen und andere Dienste nutzen können",
        apiDoc: "über die API-Dokumentation.",
        howUse: "Siehe zur Nutzung",
        part2: "Pro Benutzer können bis zu 5 API-Schlüssel erstellt werden",
        part3: "Bitte geben Sie Ihren API-Schlüssel nicht weiter, um Vermögensverluste zu vermeiden. Aus Sicherheitsgründen wird empfohlen, die IP für den API-Schlüssel zu binden, maximal 5 IPs pro Schlüssel. Geben Sie eine einzelne Adresse direkt ein, mehrere IP-Adressen mit Kommas, z. B. 192.168.1.1,192.168.1.2,192.168.1.3.",
        myApiKey: "Mein API-Schlüssel",
        ipAddress: "IP-Adresse",
        createTime: "Erstellungszeit",
        accessKey: "Zugangsschlüssel",
        bindIpAddress: "IP-Adresse binden",
        ioDays: "Verbleibende Tage",
        operation: "Aktion",
        create: "Erstellen",
        edit: "Bearbeiten",
        delete: "Löschen",
        sureDelete: "Sind Sie sicher, dass Sie löschen möchten?",
        tips: "Der Schlüssel wird nur beim Hinzufügen angezeigt, bitte rechtzeitig speichern.",
        copy: "Kopieren",
        access: "Schlüssel",
        okText: "Bestätigen",
        cancel: "Abbrechen"
    }
},
  cms: {
      noticecenter: 'Mitteilungszentrum',
      newshelp: 'Hilfe für neue Nutzer',
      appdownload: 'App herunterladen',
      onlineservice: 'Online-Service',
      faq: 'FAQ',
      notice: 'Mitteilung',
      servicecenter: 'Kundencenter',
      about: 'Über',
      joinus: 'Werde Teil unseres Teams',
      aboutus: 'Über uns',
      exchangerule: 'Handelsregeln',
      useprotocol: 'Nutzungsvereinbarung',
      feenote: 'Gebührenbeschreibung',
      merchantprocotol: 'Händlervereinbarung',
      features: "Funktionen",
      contactus: "Kontakt",
      noticelist: 'Alle Mitteilungen',
      nextnotice: 'NÄCHSTE',
      prevnotice: "VORHERIGE",
      notexist: "Die von Ihnen besuchte Seite existiert nicht oder wurde gelöscht",
      otherhelp: "Weitere in dieser Kategorie",
      scanforshare: "Zum Teilen scannen",
      download: "Herunterladen",
      downloadslogan: "BIPPAX APP – Überall handeln."
  },
  description: {
      title1: 'Sicherheit',
      title2: '24H Service',
      title3: 'Globale Börse',
      title4: 'Strenge Projekte',
      message1: 'Umfassendes Finanzkontrollsystem und Diebstahlschutz, Hot- und Cold-Wallet, Multi-Signatur-System zum Schutz der Gelder',
      message2: '24H manuelle Online-Prüfung schützt Kunden davor, die besten Investitionsmöglichkeiten zu verpassen.',
      message3: 'Globales Servicenetzwerk hilft Ihnen, weltweit in Krypto-Assets zu investieren und mit Nutzern weltweit zu handeln',
      message4: 'Wir wählen streng hochwertige Blockchain-Projekte aus und filtern 80% der Hochrisikoprojekte für Sie heraus.',
      scanqrcode: "App herunterladen",
      aboutdesc1: "BIPPAX.PRO ist eine weltweit führende Handelsplattform für digitale Vermögenswerte, registriert auf den Kaimaninseln, mit einem Kernteam in Hongkong. Die Kernmitglieder von BIPPAX.PRO stammen aus führenden Internet- und Finanzunternehmen und sind überzeugte Anhänger von Bitcoin und Blockchain. Wir sind überzeugt, dass Blockchain das traditionelle Finanzsystem verändern und eine demokratischere, autonomere Gesellschaft schaffen wird.",
      aboutdesc2: "Die BIPPAX.PRO-Plattform verfügt über eine professionelle Handelsarchitektur auf Finanzniveau und eine eigens entwickelte, hochperformante Matching-Engine. Die Plattform verwendet ein vollständiges Cold-Wallet-System + Multi-Signaturen + DDOS-Schutzsystem, um die Sicherheit der Kundenvermögen zu gewährleisten.",
      aboutdesc3: "Um Kunden bessere Investitionsmöglichkeiten zu bieten, setzt BIPPAX.PRO auf flache Hierarchien im Kundenservice und ein extrem schnelles Service-Reaktionssystem. Der Asset-Kundenservice ist 7*24H online und sorgt dafür, dass Einzahlungen innerhalb von 25 Minuten abgeschlossen werden.",
      aboutdesc4: "BIPPAX.PRO prüft Projekte streng und bietet sichere, stabile Verwahrungsdienste. Wir stehen für Ehrlichkeit, Fairness, Begeisterung und Offenheit und streben nach einer sicheren, zuverlässigen, effizienten und benutzerfreundlichen Börse.",
      aboutdesc5: "Auch wenn digitale Vermögenswerte derzeit noch eine Nische sind, glauben wir, dass sie in Zukunft populär werden. Lassen Sie uns gemeinsam daran arbeiten und gespannt sein!",
      support: "Support",
      report: "Vorschlag",
      service: "Kundenservice",
      apply: "Bewerbung",
      coop: "Kooperation",
      community: "BIPPAX Community",
      wechat: "WeChat",
      addwechat: "Fügen Sie 'coinex' als WeChat-Freund hinzu und treten Sie der Community bei",
      weibo: "Weibo",
      twitter: "Twitter",
      biyong: "Biyong",
      telegram: "Telegram",
      medium: "Medium",
      reddit: "Reddit"
  },
  bzb_description: {
      title1: "",
      title2: "",
      title3: "",
      title4: "",
      title5: "",
      title6: "",
      title7: "",
      title8: "",
      desc1: "",
      desc2: "",
      desc3: "",
      desc4: "",
      desc5: "",
      desc6: "",
      desc7: "",
      desc8: ""
  },
  footer: {
      wechatkefu: "WeChat-Service",
      notice: 'Mitteilung',
      gsmc: 'Beste Kryptowährungen handeln',
      bah: 'Nr. 13026899-3, Shanghai ICP',
      gsjj: 'Profil',
      gywm: 'Über uns',
      jrwm: 'Werde Teil unseres Teams',
      biyong: 'BiYong',
      lxwm: 'Kontakt',
      yqlj: 'Links',
      bzzx: 'Hilfe',
      xsrm: "Einsteigerkurs",
      czzn: 'Aufladeanleitung',
      jyzn: 'Handelsanleitung',
      ptsm: 'Erklärung',
      fysm: 'Gebühren',
      fwtk: 'Service-Richtlinie',
      fltk: 'Rechtliche Hinweise',
      wechat: "WeChat-Kundenservice",
      xszn: "Einsteigerleitfaden",
      cjwt: "FAQ",
      mztk: "Haftungsausschluss",
      ystk: "Datenschutzrichtlinie",
      tkxy: "Bedingungen",
      gybzb: "Über BZB",
      kfyx: "Service-E-Mail",
      swhz: "Kooperation",
      sbsq: "Marktantrag",
      jyzn: "Börsenanleitung",
      bzzl: "Coin-Info",
      tsjb: "Meldung",
      apidoc: "API-Dokumentation",
      zwkf: "Kommt bald"
  },
  index: {
      circulation: 'Sicherheits- und Entwicklungsfonds-Umlauf',
      hourEth: 'Heute zu verteilende kumulierte Einnahmen',
      yesterdayEth: 'Gestern zu verteilende kumulierte Einnahmen',
      yesterday: 'Mining-Ertrag des Vortages:',
      bhbTotal: "BHB Gesamtumlauf",
      bhbSecond: "BHB Zweitmarkt-Umlauf",
      checkMineprinciple: "Mining-Prinzip anzeigen",
      checkFlowVolum: 'Umlauf prüfen',
      checkLockPosition: 'Sperrsituation prüfen',
      BHBregister: "BIPPAX-Konto registrieren",
      tibi: "Zeit und Limit der Auszahlung",
      line_plane: "Ankündigung zum BHB-Online-Plan, Umlauf und Rückerstattung der Servicegebühr",
      fenpeijizhi: 'Beschreibung des BIPPAX-Einkommensverteilungsmechanismus',
      jiangli_jihua: "Mining-Belohnungsplan für Einladungen",
      friend_fanhuan: "Freunde einladen, zusätzliche Gebühren verdienen"
  },
  plate: {
      title: "Plattform-Einkommensverteilung (BHB-Inhaberrechte)",
      content1: "Wie im Whitepaper beschrieben, werden 80% der Plattform-Einnahmen (nach Steuern und Gebühren) an BHB-Inhaber verteilt, 20% dienen der Weiterentwicklung und dem Betrieb der Plattform.",
      content2: "Die Einkommensverteilung erfolgt täglich, beginnend am 6. Juni 2018. Danach werden die am Vortag zu verteilenden Gesamteinnahmen anteilig an die BHB-Inhaber ausgeschüttet.",
      content3: "（Hinweis: 1. BHB bezieht sich hier nur auf freigegebene/umlaufende BHB. Siehe auch【",
      content3_1: 'Hinweis zum Verhältnis von BHB-Umlauf / Teilnahme an der Einkommensverteilung',
      content3_2: "2. Der stündliche Snapshot wird einmal berechnet, die Verteilung erfolgt einmal täglich.",
      hourFenpei: "Heutige Einkommensverteilung",
      hourTotal: "Heutige Gesamteinnahmen der Plattform",
      xiangqing: "Details der heutigen Einkommensverteilung",
      yesterdaytit: "Gestern verteiltes Einkommen",
      yesterdaytotal: "Gesamteinnahmen der Plattform gestern",
      yesterdayxiangqing: "Details der gestrigen Einkommensverteilung",
      yesterday: {
          total: "Gesamteinnahmen",
          allocated: "Nicht verteilte Einnahmen",
      }
  },
  feereturn: {
      ruletitle: "Hinweis",
      rulecontent: 'Unser Whitepaper erklärt die Rückerstattung der Transaktionsgebühren im Detail. Insgesamt werden 51% der gesamten BHB-Basis der Plattform (im Folgenden als "Community-Belohnungsanteil" bezeichnet) im Laufe der Zeit über unseren "Trans-Fee Mining"-Mechanismus an die Nutzer zurückerstattet. Sobald diese 51% vollständig ausgeschüttet sind, endet der Mechanismus automatisch.',
      recordtitle: 'Liste',
      recordcontent: 'Jeden Tag (UTC+8) werden 100% der am Vortag angefallenen Transaktionsgebühren in Form von BHB zurückerstattet. Die Rückerstattung erfolgt zum durchschnittlichen BHB-Preis des Vortages (berechnet als Gesamtwert/Gesamtvolumen). Die Rückerstattung erfolgt täglich um 11 Uhr.',
      time: "Datum",
      todaycharge: "Durchschnittspreis (ETH)",
      totalChange: 'Gesamt (ETH)',
      returnCharge: "Trans-Fee Mining Rückerstattung (BHB)",
      todayChargeReturn: "FCoin Rückerstattungsprogramm (BHB)"
  },
  home: {
      login: {
          title: 'Beginnen Sie mit dem Handel von Kryptowährungen',
          desc: 'Über 500 Kryptowährungen und verschiedene Handelstools verfügbar',
          btnText: 'Jetzt handeln'
      },
      unlogin: {
          title: 'Starten Sie Ihre Reise mit digitalen Vermögenswerten',
          desc: 'Registrieren Sie sich und erhalten Sie das Willkommenspaket für neue Nutzer',
          placinfo: 'Telefon/E-Mail',
          btnText: 'Registrieren'
      },
      WelfareCenter: 'Vorteilscenter',
      Welcome_ceremony: 'Willkommensgeschenk',
      Airdrop: 'Airdrop',
      DailyGain: 'Tägliche Belohnungen',
      AirdropGift: 'Airdrop-Geschenke',
      financial_management: 'Optimiertes Finanzmanagement',
      Zhoude: 'Wöchentliche Belohnungen',
      height_is: 'bis zu',
      Happiness: 'Glücks-Carnival',
      Monthly: 'Monatliche Belohnungen',
      CarveUp: 'Preispool',
      download: {
          transactions_anytime: 'Jederzeit und überall handeln',
          scan_code: 'Zum Download scannen',
          download_more: 'Mehr herunterladen'
      },
      brand: {
          digital_platform: 'Führende Plattform für digitale Vermögenswerte',
          rich_digital: 'Vielfältige Handels- und Vermögensverwaltungsdienste für digitale Assets',
          High_quality_digital: 'Hochwertige digitale Vermögenswerte',
          Turnover: 'Umsatz',
          safety_risk: 'Weltklasse-Sicherheits- und Risikomanagementsystem',
          multi_factor: 'Offline-Speicherung, Multi-Faktor-Verschlüsselung, 24/7 Plattformüberwachung, umfassender Schutz der Nutzervermögen',
          Security_reserve: 'Sicherheitsreservefonds',
          accident: '0 Unfälle in 9 Jahren',
          safetyrisk: 'Top-Sicherheits- und Risikokontrolle',
          choice_trusted: 'Die Wahl von Millionen Nutzern',
          transaction_service: 'Lokale Servicezentren in vielen Ländern und Regionen, Aufbau eines Blockchain-Ökosystems mit vielfältigen Geschäftsformen',
          ten_thousand: '10.000',
          User_preference: 'Von Nutzern bevorzugt',
          Countries_covered: 'Abgedeckte Länder'
      },
      trading: {
          digital_currency: 'Starten Sie Ihre Reise mit digitalen Vermögenswerten',
          register: 'Registrieren',
          login: 'Anmelden',
          currency_transaction: 'Beginnen Sie mit dem Handel von Kryptowährungen',
          to_trade: 'Jetzt handeln'
      }
  }

}



// WEBPACK FOOTER //
// ./src/assets/lang/de/index.js